import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, HostListener, Inject, Directive, EventEmitter, Output, InjectionToken, Injectable, Optional, ViewChild, Pipe, TemplateRef, ContentChild, ContentChildren, forwardRef, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import * as i3$2 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i4 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i1 from '@firestitch/label';
import { FsLabelModule } from '@firestitch/label';
import { FsApiFile } from '@firestitch/api';
import { from, of, Observable, throwError, forkJoin, Subject } from 'rxjs';
import { map, tap, catchError, switchMap, takeUntil } from 'rxjs/operators';
import * as FileAPI from 'fileapi';
import * as i2$1 from '@firestitch/message';
import { MessageMode } from '@firestitch/message';
import heic2any from 'heic2any';
import { toInteger } from 'lodash-es';
import * as i1$1 from '@angular/platform-browser';

class FsFileBouncingIconComponent {
    constructor() {
        this.icon = null;
        this.size = '70px';
        this.color = null;
    }
    ngOnInit() {
    }
}
FsFileBouncingIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileBouncingIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsFileBouncingIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFileBouncingIconComponent, selector: "fs-file-bouncing-icon", inputs: { icon: "icon", size: "size", color: "color" }, ngImport: i0, template: "<mat-icon\nclass=\"bounce\"\n[ngStyle]=\"{ 'font-size': size, height: size, width: size, color: color }\"\n>{{ icon }}</mat-icon>\n", styles: [":host .bounce{display:inline-block;position:relative;animation:bounce .5s infinite linear}@keyframes bounce{0%{top:0}50%{top:-.2em}70%{top:-.3em}to{top:0}}\n"], components: [{ type: i5.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileBouncingIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-file-bouncing-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-icon\nclass=\"bounce\"\n[ngStyle]=\"{ 'font-size': size, height: size, width: size, color: color }\"\n>{{ icon }}</mat-icon>\n", styles: [":host .bounce{display:inline-block;position:relative;animation:bounce .5s infinite linear}@keyframes bounce{0%{top:0}50%{top:-.2em}70%{top:-.3em}to{top:0}}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { icon: [{
                type: Input
            }], size: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

class FsFileDragBaseComponent {
    constructor() {
        this.dragging = 0;
        this.dragover = null;
        this.drop = null;
        this.fileOverTarget = false;
    }
    onDragOverElement() {
        if (!this.dragover && !this.drop) {
            this.dragover = this.onWindowDragOver.bind(this);
            this.drop = this.onWindowDrop.bind(this);
            window.addEventListener('dragover', this.dragover);
            window.addEventListener('drop', this.drop);
        }
        this.dragging++;
        this.fileOverTarget = true;
    }
    onDragLeaveElement(event) {
        this.dragging--;
        if (this.dragging === 0) {
            this.fileOverTarget = false;
        }
    }
    onDropElement() {
        this.fileOverTarget = false;
    }
    // // Disable dropping files into th browser window ie file://...
    onWindowDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        // this.ngOnDestroy();
        this.dragging = 0;
        return false;
    }
    // // Disable dropping files into th browser window ie file://...
    onWindowDragOver(event) {
        event.stopPropagation();
        event.preventDefault();
        return false;
    }
    ngOnDestroy() {
        window.removeEventListener('dragover', this.dragover);
        window.removeEventListener('drop', this.drop);
        this.drop = null;
        this.dragover = null;
    }
}
FsFileDragBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileDragBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsFileDragBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFileDragBaseComponent, selector: "fs-file-drag-base", host: { listeners: { "dragenter": "onDragOverElement()", "dragleave": "onDragLeaveElement($event)", "drop": "onDropElement()" }, properties: { "class.dragover": "this.fileOverTarget" } }, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileDragBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-file-drag-base',
                    template: '',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { fileOverTarget: [{
                type: HostBinding,
                args: ['class.dragover']
            }], onDragOverElement: [{
                type: HostListener,
                args: ['dragenter']
            }], onDragLeaveElement: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], onDropElement: [{
                type: HostListener,
                args: ['drop']
            }] } });

class FsFileDragoverMessageComponent {
    constructor() { }
    ngOnInit() {
    }
}
FsFileDragoverMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileDragoverMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsFileDragoverMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFileDragoverMessageComponent, selector: "fs-file-dragover-message", ngImport: i0, template: "<div class=\"dragover-message\">\n  <fs-file-bouncing-icon icon=\"upload\"></fs-file-bouncing-icon>\n  <div class=\"content\">\n    Drop file to instantly upload them\n  </div>\n</div>\n", styles: [":host .dragover-message{position:fixed;bottom:10px;left:50%;transform:translate(-50%);flex-direction:column;align-items:center}:host .dragover-message .content{color:#fff;padding:16px 20px;border-radius:2px}\n"], components: [{ type: FsFileBouncingIconComponent, selector: "fs-file-bouncing-icon", inputs: ["icon", "size", "color"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileDragoverMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-file-dragover-message', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"dragover-message\">\n  <fs-file-bouncing-icon icon=\"upload\"></fs-file-bouncing-icon>\n  <div class=\"content\">\n    Drop file to instantly upload them\n  </div>\n</div>\n", styles: [":host .dragover-message{position:fixed;bottom:10px;left:50%;transform:translate(-50%);flex-direction:column;align-items:center}:host .dragover-message .content{color:#fff;padding:16px 20px;border-radius:2px}\n"] }]
        }], ctorParameters: function () { return []; } });

class FsFileImagePickerDialogComponent {
    constructor(data) {
        this.data = data;
        this.reverseUrl = '';
        if (data.file) {
            this.reverseUrl = 'https://images.google.com/searchbyimage?image_url=' + encodeURIComponent(data.file.url);
        }
        this.selectUrl = this.data.selectUrl;
    }
    imageLoad(event) {
        this.height = event.target.naturalHeight;
        this.width = event.target.naturalWidth;
    }
    upload() {
    }
}
FsFileImagePickerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileImagePickerDialogComponent, deps: [{ token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
FsFileImagePickerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFileImagePickerDialogComponent, selector: "ng-component", ngImport: i0, template: "<h1 mat-dialog-title>Image</h1>\n<mat-dialog-content>\n\n  <div *ngIf=\"data.file\" class=\"details\">\n      <a [href]=\"data.file.url\" target=\"_blank\" class=\"image-url\"><img class=\"image\" [src]=\"data.file.url\" (load)=\"imageLoad($event)\"></a>\n    <br>\n    <fs-label-field>\n      <fs-label>Image Size</fs-label>\n      {{width}} x {{height}}\n    </fs-label-field>\n\n    <fs-label-field>\n      <fs-label>Image Url</fs-label>\n      <a [href]=\"data.file.url\" target=\"_blank\" class=\"url\">{{data.file.url}}</a>\n    </fs-label-field>\n  </div>\n\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-button mat-dialog-close color=\"primary\">Done</button>\n  <button mat-button mat-dialog-close (click)=\"upload()\" *ngIf=\"selectUrl.observers.length\">Upload Via URL</button>\n  <a mat-button [href]=\"reverseUrl\" target=\"_blank\" type=\"button\" *ngIf=\"reverseUrl\">Reverse Image Lookup</a>\n</mat-dialog-actions>", styles: [".image{max-width:100%;margin:auto;max-height:400px}.image-url{align-self:center}.details{display:flex;flex-direction:column}.url{word-break:break-all}\n"], components: [{ type: i1.FsLabelFieldComponent, selector: "fs-label-field", inputs: ["bottomMargin", "topMargin", "labelMargin"] }, { type: i1.FsLabelComponent, selector: "fs-label" }, { type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i2.MatAnchor, selector: "a[mat-button], a[mat-raised-button], a[mat-icon-button], a[mat-fab],             a[mat-mini-fab], a[mat-stroked-button], a[mat-flat-button]", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matButton", "matAnchor"] }], directives: [{ type: i3$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i3$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i3$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileImagePickerDialogComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<h1 mat-dialog-title>Image</h1>\n<mat-dialog-content>\n\n  <div *ngIf=\"data.file\" class=\"details\">\n      <a [href]=\"data.file.url\" target=\"_blank\" class=\"image-url\"><img class=\"image\" [src]=\"data.file.url\" (load)=\"imageLoad($event)\"></a>\n    <br>\n    <fs-label-field>\n      <fs-label>Image Size</fs-label>\n      {{width}} x {{height}}\n    </fs-label-field>\n\n    <fs-label-field>\n      <fs-label>Image Url</fs-label>\n      <a [href]=\"data.file.url\" target=\"_blank\" class=\"url\">{{data.file.url}}</a>\n    </fs-label-field>\n  </div>\n\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-button mat-dialog-close color=\"primary\">Done</button>\n  <button mat-button mat-dialog-close (click)=\"upload()\" *ngIf=\"selectUrl.observers.length\">Upload Via URL</button>\n  <a mat-button [href]=\"reverseUrl\" target=\"_blank\" type=\"button\" *ngIf=\"reverseUrl\">Reverse Image Lookup</a>\n</mat-dialog-actions>", styles: [".image{max-width:100%;margin:auto;max-height:400px}.image-url{align-self:center}.details{display:flex;flex-direction:column}.url{word-break:break-all}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class FsFileHintDirective {
}
FsFileHintDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileHintDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsFileHintDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsFileHintDirective, selector: "[fsFileHint][fsFileLabelMessage]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileHintDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsFileHint][fsFileLabelMessage]'
                }]
        }] });

class FsFileLabelDirective {
}
FsFileLabelDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileLabelDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsFileLabelDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsFileLabelDirective, selector: "[fsFileLabel]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsFileLabel]'
                }]
        }] });

class FsFilePickerSelectDirective {
}
FsFilePickerSelectDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePickerSelectDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsFilePickerSelectDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsFilePickerSelectDirective, selector: "[fsFilePickerSelect]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePickerSelectDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsFilePickerSelect]'
                }]
        }] });

class FsFilePreviewActionDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.click = new EventEmitter();
    }
}
FsFilePreviewActionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePreviewActionDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
FsFilePreviewActionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsFilePreviewActionDirective, selector: "[fs-file-preview-action]", inputs: { placement: "placement", tooltip: "tooltip", action: "action", hide: "hide", forTypes: ["for-types", "forTypes"] }, outputs: { click: "click" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePreviewActionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fs-file-preview-action]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { placement: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], action: [{
                type: Input
            }], hide: [{
                type: Input
            }], forTypes: [{
                type: Input,
                args: ['for-types']
            }], click: [{
                type: Output
            }] } });

class Exif {
    constructor() {
        this.debug = false;
        this.root = this;
        this.Tags = {
            // version tags
            0x9000: "ExifVersion",
            0xA000: "FlashpixVersion",
            // colorspace tags
            0xA001: "ColorSpace",
            // image configuration
            0xA002: "PixelXDimension",
            0xA003: "PixelYDimension",
            0x9101: "ComponentsConfiguration",
            0x9102: "CompressedBitsPerPixel",
            // user information
            0x927C: "MakerNote",
            0x9286: "UserComment",
            // related file
            0xA004: "RelatedSoundFile",
            // date and time
            0x9003: "DateTimeOriginal",
            0x9004: "DateTimeDigitized",
            0x9290: "SubsecTime",
            0x9291: "SubsecTimeOriginal",
            0x9292: "SubsecTimeDigitized",
            // picture-taking conditions
            0x829A: "ExposureTime",
            0x829D: "FNumber",
            0x8822: "ExposureProgram",
            0x8824: "SpectralSensitivity",
            0x8827: "ISOSpeedRatings",
            0x8828: "OECF",
            0x9201: "ShutterSpeedValue",
            0x9202: "ApertureValue",
            0x9203: "BrightnessValue",
            0x9204: "ExposureBias",
            0x9205: "MaxApertureValue",
            0x9206: "SubjectDistance",
            0x9207: "MeteringMode",
            0x9208: "LightSource",
            0x9209: "Flash",
            0x9214: "SubjectArea",
            0x920A: "FocalLength",
            0xA20B: "FlashEnergy",
            0xA20C: "SpatialFrequencyResponse",
            0xA20E: "FocalPlaneXResolution",
            0xA20F: "FocalPlaneYResolution",
            0xA210: "FocalPlaneResolutionUnit",
            0xA214: "SubjectLocation",
            0xA215: "ExposureIndex",
            0xA217: "SensingMethod",
            0xA300: "FileSource",
            0xA301: "SceneType",
            0xA302: "CFAPattern",
            0xA401: "CustomRendered",
            0xA402: "ExposureMode",
            0xA403: "WhiteBalance",
            0xA404: "DigitalZoomRation",
            0xA405: "FocalLengthIn35mmFilm",
            0xA406: "SceneCaptureType",
            0xA407: "GainControl",
            0xA408: "Contrast",
            0xA409: "Saturation",
            0xA40A: "Sharpness",
            0xA40B: "DeviceSettingDescription",
            0xA40C: "SubjectDistanceRange",
            // other tags
            0xA005: "InteroperabilityIFDPointer",
            0xA420: "ImageUniqueID" // Identifier assigned uniquely to each image
        };
        this.TiffTags = {
            0x0100: "ImageWidth",
            0x0101: "ImageHeight",
            0x8769: "ExifIFDPointer",
            0x8825: "GPSInfoIFDPointer",
            0xA005: "InteroperabilityIFDPointer",
            0x0102: "BitsPerSample",
            0x0103: "Compression",
            0x0106: "PhotometricInterpretation",
            0x0112: "Orientation",
            0x0115: "SamplesPerPixel",
            0x011C: "PlanarConfiguration",
            0x0212: "YCbCrSubSampling",
            0x0213: "YCbCrPositioning",
            0x011A: "XResolution",
            0x011B: "YResolution",
            0x0128: "ResolutionUnit",
            0x0111: "StripOffsets",
            0x0116: "RowsPerStrip",
            0x0117: "StripByteCounts",
            0x0201: "JPEGInterchangeFormat",
            0x0202: "JPEGInterchangeFormatLength",
            0x012D: "TransferFunction",
            0x013E: "WhitePoint",
            0x013F: "PrimaryChromaticities",
            0x0211: "YCbCrCoefficients",
            0x0214: "ReferenceBlackWhite",
            0x0132: "DateTime",
            0x010E: "ImageDescription",
            0x010F: "Make",
            0x0110: "Model",
            0x0131: "Software",
            0x013B: "Artist",
            0x8298: "Copyright"
        };
        this.GPSTags = {
            0x0000: "GPSVersionID",
            0x0001: "GPSLatitudeRef",
            0x0002: "GPSLatitude",
            0x0003: "GPSLongitudeRef",
            0x0004: "GPSLongitude",
            0x0005: "GPSAltitudeRef",
            0x0006: "GPSAltitude",
            0x0007: "GPSTimeStamp",
            0x0008: "GPSSatellites",
            0x0009: "GPSStatus",
            0x000A: "GPSMeasureMode",
            0x000B: "GPSDOP",
            0x000C: "GPSSpeedRef",
            0x000D: "GPSSpeed",
            0x000E: "GPSTrackRef",
            0x000F: "GPSTrack",
            0x0010: "GPSImgDirectionRef",
            0x0011: "GPSImgDirection",
            0x0012: "GPSMapDatum",
            0x0013: "GPSDestLatitudeRef",
            0x0014: "GPSDestLatitude",
            0x0015: "GPSDestLongitudeRef",
            0x0016: "GPSDestLongitude",
            0x0017: "GPSDestBearingRef",
            0x0018: "GPSDestBearing",
            0x0019: "GPSDestDistanceRef",
            0x001A: "GPSDestDistance",
            0x001B: "GPSProcessingMethod",
            0x001C: "GPSAreaInformation",
            0x001D: "GPSDateStamp",
            0x001E: "GPSDifferential"
        };
        // EXIF 2.3 Spec
        this.IFD1Tags = {
            0x0100: "ImageWidth",
            0x0101: "ImageHeight",
            0x0102: "BitsPerSample",
            0x0103: "Compression",
            0x0106: "PhotometricInterpretation",
            0x0111: "StripOffsets",
            0x0112: "Orientation",
            0x0115: "SamplesPerPixel",
            0x0116: "RowsPerStrip",
            0x0117: "StripByteCounts",
            0x011A: "XResolution",
            0x011B: "YResolution",
            0x011C: "PlanarConfiguration",
            0x0128: "ResolutionUnit",
            0x0201: "JpegIFOffset",
            0x0202: "JpegIFByteCount",
            0x0211: "YCbCrCoefficients",
            0x0212: "YCbCrSubSampling",
            0x0213: "YCbCrPositioning",
            0x0214: "ReferenceBlackWhite"
        };
        this.isXmpEnabled = false;
        this.StringValues = {
            ExposureProgram: {
                0: "Not defined",
                1: "Manual",
                2: "Normal program",
                3: "Aperture priority",
                4: "Shutter priority",
                5: "Creative program",
                6: "Action program",
                7: "Portrait mode",
                8: "Landscape mode"
            },
            MeteringMode: {
                0: "Unknown",
                1: "Average",
                2: "CenterWeightedAverage",
                3: "Spot",
                4: "MultiSpot",
                5: "Pattern",
                6: "Partial",
                255: "Other"
            },
            LightSource: {
                0: "Unknown",
                1: "Daylight",
                2: "Fluorescent",
                3: "Tungsten (incandescent light)",
                4: "Flash",
                9: "Fine weather",
                10: "Cloudy weather",
                11: "Shade",
                12: "Daylight fluorescent (D 5700 - 7100K)",
                13: "Day white fluorescent (N 4600 - 5400K)",
                14: "Cool white fluorescent (W 3900 - 4500K)",
                15: "White fluorescent (WW 3200 - 3700K)",
                17: "Standard light A",
                18: "Standard light B",
                19: "Standard light C",
                20: "D55",
                21: "D65",
                22: "D75",
                23: "D50",
                24: "ISO studio tungsten",
                255: "Other"
            },
            Flash: {
                0x0000: "Flash did not fire",
                0x0001: "Flash fired",
                0x0005: "Strobe return light not detected",
                0x0007: "Strobe return light detected",
                0x0009: "Flash fired, compulsory flash mode",
                0x000D: "Flash fired, compulsory flash mode, return light not detected",
                0x000F: "Flash fired, compulsory flash mode, return light detected",
                0x0010: "Flash did not fire, compulsory flash mode",
                0x0018: "Flash did not fire, auto mode",
                0x0019: "Flash fired, auto mode",
                0x001D: "Flash fired, auto mode, return light not detected",
                0x001F: "Flash fired, auto mode, return light detected",
                0x0020: "No flash function",
                0x0041: "Flash fired, red-eye reduction mode",
                0x0045: "Flash fired, red-eye reduction mode, return light not detected",
                0x0047: "Flash fired, red-eye reduction mode, return light detected",
                0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
                0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
                0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
                0x0059: "Flash fired, auto mode, red-eye reduction mode",
                0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
                0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
            },
            SensingMethod: {
                1: "Not defined",
                2: "One-chip color area sensor",
                3: "Two-chip color area sensor",
                4: "Three-chip color area sensor",
                5: "Color sequential area sensor",
                7: "Trilinear sensor",
                8: "Color sequential linear sensor"
            },
            SceneCaptureType: {
                0: "Standard",
                1: "Landscape",
                2: "Portrait",
                3: "Night scene"
            },
            SceneType: {
                1: "Directly photographed"
            },
            CustomRendered: {
                0: "Normal process",
                1: "Custom process"
            },
            WhiteBalance: {
                0: "Auto white balance",
                1: "Manual white balance"
            },
            GainControl: {
                0: "None",
                1: "Low gain up",
                2: "High gain up",
                3: "Low gain down",
                4: "High gain down"
            },
            Contrast: {
                0: "Normal",
                1: "Soft",
                2: "Hard"
            },
            Saturation: {
                0: "Normal",
                1: "Low saturation",
                2: "High saturation"
            },
            Sharpness: {
                0: "Normal",
                1: "Soft",
                2: "Hard"
            },
            SubjectDistanceRange: {
                0: "Unknown",
                1: "Macro",
                2: "Close view",
                3: "Distant view"
            },
            FileSource: {
                3: "DSC"
            },
            Components: {
                0: "",
                1: "Y",
                2: "Cb",
                3: "Cr",
                4: "R",
                5: "G",
                6: "B"
            }
        };
        this.IptcFieldMap = {
            0x78: 'caption',
            0x6E: 'credit',
            0x19: 'keywords',
            0x37: 'dateCreated',
            0x50: 'byline',
            0x55: 'bylineTitle',
            0x7A: 'captionWriter',
            0x69: 'headline',
            0x74: 'copyright',
            0x0F: 'category'
        };
    }
    addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        }
        else if (element.attachEvent) {
            element.attachEvent("on" + event, handler);
        }
    }
    imageHasData(img) {
        return !!(img.exifdata);
    }
    base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }
    objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function (e) {
            if (this.status == 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }
    getImageData(img, callback) {
        const handleBinaryFile = (binFile) => {
            var data = this.findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = this.findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (this.isXmpEnabled) {
                var xmpdata = this.findXMPinJPEG(binFile);
                img.xmpdata = xmpdata || {};
            }
            if (callback) {
                callback.call(img);
            }
        };
        if (img.src) {
            if (/^data\:/i.test(img.src)) { // Data URI
                var arrayBuffer = this.base64ToArrayBuffer(img.src, null);
                handleBinaryFile(arrayBuffer);
            }
            else if (/^blob\:/i.test(img.src)) { // Object URL
                var fileReader = new FileReader();
                fileReader.onload = (e) => {
                    handleBinaryFile(e.target.result);
                };
                this.objectURLToBlob(img.src, (blob) => {
                    fileReader.readAsArrayBuffer(blob);
                });
            }
            else {
                var http = new XMLHttpRequest();
                http.onload = function () {
                    if (this.status == 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    }
                    else {
                        throw "Could not load image";
                    }
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        }
        else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = (e) => {
                if (this.debug)
                    console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };
            fileReader.readAsArrayBuffer(img);
        }
    }
    findEXIFinJPEG(file) {
        var dataView = new DataView(file);
        if (this.debug)
            console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (this.debug)
                console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength, marker;
        while (offset < length) {
            if (dataView.getUint8(offset) != 0xFF) {
                if (this.debug)
                    console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }
            marker = dataView.getUint8(offset + 1);
            if (this.debug)
                console.log(marker);
            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data
            if (marker == 225) {
                if (this.debug)
                    console.log("Found 0xFFE1 marker");
                return this.readEXIFData(dataView, offset + 4);
                // offset += 2 + file.getShortAt(offset+2, true);
            }
            else {
                offset += 2 + dataView.getUint16(offset + 2);
            }
        }
    }
    findIPTCinJPEG(file) {
        var dataView = new DataView(file);
        if (this.debug)
            console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (this.debug)
                console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength;
        var isFieldSegmentStart = function (dataView, offset) {
            return (dataView.getUint8(offset) === 0x38 &&
                dataView.getUint8(offset + 1) === 0x42 &&
                dataView.getUint8(offset + 2) === 0x49 &&
                dataView.getUint8(offset + 3) === 0x4D &&
                dataView.getUint8(offset + 4) === 0x04 &&
                dataView.getUint8(offset + 5) === 0x04);
        };
        while (offset < length) {
            if (isFieldSegmentStart(dataView, offset)) {
                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0)
                    nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }
                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
                return this.readIPTCData(file, startOffset, sectionLength);
            }
            // Not the marker, continue searching
            offset++;
        }
    }
    readIPTCData(file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while (segmentStartPos < startOffset + sectionLength) {
            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in this.IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    segmentSize = dataSize + 5;
                    fieldName = this.IptcFieldMap[segmentType];
                    fieldValue = this.getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }
            }
            segmentStartPos++;
        }
        return data;
    }
    readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd), tags = {}, entryOffset, tag, i;
        for (i = 0; i < entries; i++) {
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && this.debug)
                console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = this.readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }
    readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd), numValues = file.getUint32(entryOffset + 4, !bigEnd), valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart, offset, vals, val, n, numerator, denominator;
        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues == 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                }
                else {
                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }
            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return this.getStringFromDB(file, offset, numValues - 1);
            case 3: // short, 16 bit int
                if (numValues == 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                }
                else {
                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                    }
                    return vals;
                }
            case 4: // long, 32 bit int
                if (numValues == 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }
            case 5: // rational = two long values, first is numerator, second is denominator
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }
            case 9: // slong, 32 bit signed int
                if (numValues == 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }
            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues == 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                    }
                    return vals;
                }
        }
    }
    /**
    * Given an IFD (Image File Directory) start offset
    * returns an offset to next IFD or 0 if it's the last IFD.
    */
    getNextIFDOffset(dataView, dirStart, bigEnd) {
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);
        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.
        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }
    readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd) {
        // get the IFD1 offset
        var IFD1OffsetPointer = this.getNextIFDOffset(dataView, tiffStart + firstIFDOffset, bigEnd);
        if (!IFD1OffsetPointer) {
            // console.log('******** IFD1Offset is empty, image thumb not found ********');
            return {};
        }
        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
            return {};
        }
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);
        var thumbTags = this.readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, this.IFD1Tags, bigEnd);
        // EXIF 2.3 specification for JPEG format thumbnail
        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.
        if (thumbTags['Compression']) {
            // console.log('Thumbnail image found!');
            switch (thumbTags['Compression']) {
                case 6:
                    // console.log('Thumbnail image format is JPEG');
                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                        // extract the thumbnail
                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
                        var tLength = thumbTags.JpegIFByteCount;
                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
                            type: 'image/jpeg'
                        });
                    }
                    break;
                case 1:
                    console.log("Thumbnail image format is TIFF, which is not implemented.");
                    break;
                default:
                    console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
            }
        }
        else if (thumbTags['PhotometricInterpretation'] == 2) {
            console.log("Thumbnail image format is RGB, which is not implemented.");
        }
        return thumbTags;
    }
    getStringFromDB(buffer, start, length) {
        var outstr = "";
        for (var n = start; n < start + length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }
    readEXIFData(file, start) {
        if (this.getStringFromDB(file, start, 4) != "Exif") {
            if (this.debug)
                console.log("Not valid EXIF data! " + this.getStringFromDB(file, start, 4));
            return false;
        }
        var bigEnd, tags, tag, exifData, gpsData, tiffOffset = start + 6;
        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) {
            bigEnd = false;
        }
        else if (file.getUint16(tiffOffset) == 0x4D4D) {
            bigEnd = true;
        }
        else {
            if (this.debug)
                console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }
        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
            if (this.debug)
                console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }
        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
        if (firstIFDOffset < 0x00000008) {
            if (this.debug)
                console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
            return false;
        }
        tags = this.readTags(file, tiffOffset, tiffOffset + firstIFDOffset, this.TiffTags, bigEnd);
        if (tags.ExifIFDPointer) {
            exifData = this.readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, this.Tags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case "LightSource":
                    case "Flash":
                    case "MeteringMode":
                    case "ExposureProgram":
                    case "SensingMethod":
                    case "SceneCaptureType":
                    case "SceneType":
                    case "CustomRendered":
                    case "WhiteBalance":
                    case "GainControl":
                    case "Contrast":
                    case "Saturation":
                    case "Sharpness":
                    case "SubjectDistanceRange":
                    case "FileSource":
                        exifData[tag] = this.StringValues[tag][exifData[tag]];
                        break;
                    case "ExifVersion":
                    case "FlashpixVersion":
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;
                    case "ComponentsConfiguration":
                        exifData[tag] =
                            this.StringValues.Components[exifData[tag][0]] +
                                this.StringValues.Components[exifData[tag][1]] +
                                this.StringValues.Components[exifData[tag][2]] +
                                this.StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }
        if (tags.GPSInfoIFDPointer) {
            gpsData = this.readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, this.GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case "GPSVersionID":
                        gpsData[tag] = gpsData[tag][0] +
                            "." + gpsData[tag][1] +
                            "." + gpsData[tag][2] +
                            "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }
        // extract thumbnail
        tags['thumbnail'] = this.readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
        return tags;
    }
    findXMPinJPEG(file) {
        if (!('DOMParser' in self)) {
            // console.warn('XML parsing not supported without DOMParser');
            return;
        }
        var dataView = new DataView(file);
        if (this.debug)
            console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (this.debug)
                console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength, dom = new DOMParser();
        while (offset < (length - 4)) {
            if (this.getStringFromDB(dataView, offset, 4) == "http") {
                var startOffset = offset - 1;
                var sectionLength = dataView.getUint16(offset - 2) - 1;
                var xmpString = this.getStringFromDB(dataView, startOffset, sectionLength);
                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
                xmpString = xmpString.substring(xmpString.indexOf('<x:xmpmeta'), xmpEndIndex);
                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10;
                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
                //Without these namespaces, XML is thought to be invalid by parsers
                xmpString = xmpString.slice(0, indexOfXmp)
                    + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
                    + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
                    + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
                    + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
                    + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
                    + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
                    + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
                    + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
                    + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
                    + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
                    + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
                    + xmpString.slice(indexOfXmp);
                var domDocument = dom.parseFromString(xmpString, 'text/xml');
                return this.xml2Object(domDocument);
            }
            else {
                offset++;
            }
        }
    }
    xml2json(xml) {
        var json = {};
        if (xml.nodeType == 1) { // element node
            if (xml.attributes.length > 0) {
                json['@attributes'] = {};
                for (var j = 0; j < xml.attributes.length; j++) {
                    var attribute = xml.attributes.item(j);
                    json['@attributes'][attribute.nodeName] = attribute.nodeValue;
                }
            }
        }
        else if (xml.nodeType == 3) { // text node
            return xml.nodeValue;
        }
        // deal with children
        if (xml.hasChildNodes()) {
            for (var i = 0; i < xml.childNodes.length; i++) {
                var child = xml.childNodes.item(i);
                var nodeName = child.nodeName;
                if (json[nodeName] == null) {
                    json[nodeName] = this.xml2json(child);
                }
                else {
                    if (json[nodeName].push == null) {
                        var old = json[nodeName];
                        json[nodeName] = [];
                        json[nodeName].push(old);
                    }
                    json[nodeName].push(this.xml2json(child));
                }
            }
        }
        return json;
    }
    xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) {
                for (var i = 0; i < xml.children.length; i++) {
                    var item = xml.children.item(i);
                    var attributes = item.attributes;
                    for (var idx in attributes) {
                        var itemAtt = attributes[idx];
                        var dataKey = itemAtt.nodeName;
                        var dataValue = itemAtt.nodeValue;
                        if (dataKey !== undefined) {
                            obj[dataKey] = dataValue;
                        }
                    }
                    var nodeName = item.nodeName;
                    if (typeof (obj[nodeName]) == "undefined") {
                        obj[nodeName] = this.xml2json(item);
                    }
                    else {
                        if (typeof (obj[nodeName].push) == "undefined") {
                            var old = obj[nodeName];
                            obj[nodeName] = [];
                            obj[nodeName].push(old);
                        }
                        obj[nodeName].push(this.xml2json(item));
                    }
                }
            }
            else {
                obj = xml.textContent;
            }
            return obj;
        }
        catch (e) {
            console.log(e.message);
        }
    }
    getData(img, callback) {
        if (((self.Image && img instanceof self.Image)
            || (self.HTMLImageElement && img instanceof self.HTMLImageElement))
            && !img.complete)
            return false;
        if (!this.imageHasData(img)) {
            this.getImageData(img, callback);
        }
        else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    }
    getTag(img, tag) {
        if (!this.imageHasData(img))
            return;
        return img.exifdata[tag];
    }
    getIptcTag(img, tag) {
        if (!this.imageHasData(img))
            return;
        return img.iptcdata[tag];
    }
    getAllTags(img) {
        if (!this.imageHasData(img))
            return {};
        var a, data = img.exifdata, tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }
    getAllIptcTags(img) {
        if (!this.imageHasData(img))
            return {};
        var a, data = img.iptcdata, tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }
    pretty(img) {
        if (!this.imageHasData(img))
            return "";
        var a, data = img.exifdata, strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] == "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    }
                    else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                }
                else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    }
    readFromBinaryFile(file) {
        return this.findEXIFinJPEG(file);
    }
}

class FsFile {
    constructor(obj, filename) {
        this.progress = false;
        this.url = '';
        this._fileExists = false;
        this._init(obj, filename);
        this._checkIfFileExists();
    }
    get imageWidth() {
        return from(this.dims)
            .pipe(map((dims) => dims.width))
            .toPromise();
    }
    get imageHeight() {
        return from(this.dims)
            .pipe(map((dims) => dims.height))
            .toPromise();
    }
    get exifInfo() {
        return new Promise((resolve, reject) => {
            this.imageInfo
                .then((data) => {
                resolve(data.exif);
            }, reject);
        });
    }
    get typeImage() {
        return this.type.match(/^image/) !== null;
    }
    get typeSvg() {
        return this.type.match(/\/svg/);
    }
    get imageProcess() {
        return this.typeImage && !this.typeSvg;
    }
    get apiFile() {
        return this._apiFile;
    }
    get exists() {
        return this._fileExists;
    }
    isExtension(extension) {
        const extensions = (Array.isArray(extension) ? extension : [extension])
            .map((extension) => extension.toLowerCase());
        return extensions.indexOf(this.extension) !== -1;
    }
    get file() {
        return this._file;
    }
    set file(value) {
        this._file = value;
        this.size = value.size;
        this.type = value.type;
        this.name = value.name;
        this._checkIfFileExists();
    }
    get name() {
        return this._name;
    }
    set name(name) {
        this._name = name;
        const parts = String(name).split('.');
        if (parts.length > 1) {
            this.extension = parts[parts.length - 1].toLowerCase();
        }
    }
    get dims() {
        if (this._imageHeight || this._imageWidth) {
            return of({
                width: this._imageWidth,
                height: this._imageHeight,
            })
                .toPromise();
        }
        return new Observable((observer) => {
            FileAPI.getInfo(this.file, (err, info) => {
                if (!err) {
                    observer.next(info);
                    observer.complete();
                }
                else {
                    observer.error(err);
                }
            });
        })
            .pipe(tap((dims) => {
            this._imageWidth = dims.width;
            this._imageHeight = dims.height;
        }))
            .toPromise();
    }
    get imageInfo() {
        if (!this.typeImage || this._exifInfo) {
            return Promise.resolve({
                width: this._imageWidth,
                height: this._imageHeight,
                exif: this._exifInfo,
            });
        }
        const exif$ = new Observable((observer) => {
            const fr = new FileReader();
            fr.onload = () => {
                const exif = (new Exif()).readFromBinaryFile(fr.result);
                if (exif) {
                    observer.next(exif);
                    observer.complete();
                }
                else {
                    observer.error('Failed to read from binary file');
                }
            };
            fr.onerror = () => {
                observer.error(fr.error);
            };
            fr.readAsArrayBuffer(this.file);
        });
        return from(this.dims)
            .pipe(catchError(null), switchMap(() => exif$
            .pipe(tap((exif) => {
            this._exifInfo = exif || {};
        }), catchError(() => of(true)))), map(() => ({
            width: this._imageWidth,
            height: this._imageHeight,
            exif: this._exifInfo,
        })))
            .toPromise();
    }
    download() {
        const href = this.file instanceof File ?
            URL.createObjectURL(this.file) :
            this.file;
        const link = document.createElement('a');
        link.href = href;
        link.download = this.name;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    toObject() {
        return {
            name: this._name,
            type: this.type,
            size: this.size,
            progress: this.progress,
            extension: this.extension,
            imageWidth: this.imageWidth,
            imageHeight: this.imageHeight,
        };
    }
    get base64() {
        if (this._apiFile) {
            return this._apiFile.base64;
        }
        if (this.file instanceof File) {
            return new Observable((observer) => {
                const reader = new FileReader();
                reader.readAsDataURL(this._file);
                reader.onload = () => {
                    observer.next(reader.result);
                    observer.complete();
                };
                reader.onerror = (error) => observer.error(error);
            });
        }
        return throwError('Unable to create base64');
    }
    get blobUrl() {
        if (this._apiFile) {
            return this._apiFile.blobUrl;
        }
        if (this.file instanceof File) {
            return of(URL.createObjectURL(this.file));
        }
        return throwError('Unable to create blobUrl');
    }
    _checkIfFileExists() {
        this._fileExists = !!this.url || !!this.size || !!this.apiFile;
    }
    _init(obj, filename) {
        if (obj instanceof File) {
            return this.file = obj;
        }
        let type;
        let fileBlob = [];
        if (obj instanceof Blob) {
            fileBlob = [obj];
            if (obj.type) {
                type = obj.type;
                if (!filename) {
                    filename = `file.${obj.type.split('/').pop()}`;
                }
            }
        }
        else if (typeof obj === 'string') {
            const url = new URL(obj);
            filename = filename || url.pathname.split('/').pop();
            this.url = url.href;
        }
        else if (obj instanceof FsApiFile) {
            this._apiFile = obj;
            filename = filename || this._apiFile.name;
        }
        if (filename) {
            const match = filename.toLowerCase().match(/([^\.]+)$/);
            this.extension = match ? match[1].toLowerCase() : '';
            type = `${this._getExtensionMime()}/${this.extension}`;
        }
        this.file = new File(fileBlob, filename || '', { type });
    }
    _getExtensionMime() {
        return this.extension.match(/(jpe?g|png|gif|tiff?|bmp|svg|heic|heif)/) ? 'image' : 'application';
    }
}

class FileProcessConfig {
    constructor(config = {}) {
        this._quality = 1;
        this._orientate = true;
        this._heic = false;
        this.maxWidth = config.maxWidth;
        this.maxHeight = config.maxHeight;
        this.format = config.format;
        this.orientate = config.orientate ?? true;
        this.minWidth = config.minWidth;
        this.minHeight = config.minHeight;
    }
    set maxWidth(value) {
        if (value !== undefined) {
            this._maxWidth = +value;
        }
    }
    get maxWidth() {
        return this._maxWidth;
    }
    set maxHeight(value) {
        if (value !== undefined) {
            this._maxHeight = +value;
        }
    }
    get maxHeight() {
        return this._maxHeight;
    }
    set quality(value) {
        const val = parseFloat(value);
        if (!isNaN(val)) {
            this._quality = val;
        }
    }
    get quality() {
        return this._quality;
    }
    set format(value) {
        if (['jpg', 'png'].indexOf(value) > -1) {
            this._format = value;
        }
    }
    get format() {
        return this._format;
    }
    get orientate() {
        return this._orientate;
    }
    set orientate(value) {
        this._orientate = value;
    }
    set minWidth(value) {
        this._minWidth = value;
    }
    get minWidth() {
        return this._minWidth;
    }
    set minHeight(value) {
        this._minHeight = value;
    }
    get minHeight() {
        return this._minHeight;
    }
}

class FileProcessor {
    processFile(fsFile, config) {
        const processConfig = config instanceof FileProcessConfig ? config : new FileProcessConfig(config);
        return this._transform(fsFile, processConfig)
            .pipe(switchMap((item) => this._validate(item, processConfig)));
    }
    processFiles(fsFiles, config) {
        const errors = [];
        return forkJoin(fsFiles.map((fsFile) => this.processFile(fsFile, config)
            .pipe(catchError((error) => {
            errors.push(error);
            return of(null);
        }))))
            .pipe(switchMap((result) => {
            if (errors.length) {
                const error = errors
                    .reduce((accum, item) => {
                    return [
                        ...accum,
                        item.error,
                    ];
                }, [])
                    .join(', ');
                const code = errors
                    .reduce((accum, item) => {
                    return [
                        ...accum,
                        item.code,
                    ];
                }, [])
                    .join(', ');
                return throwError({ error, code, message: error });
            }
            return of(result);
        }));
    }
    _validate(fsFile, processConfig) {
        if (processConfig.minHeight || processConfig.minWidth) {
            return from(fsFile.imageInfo)
                .pipe(switchMap((data) => {
                if (data.height < toInteger(processConfig.minHeight)) {
                    return throwError({ error: `Height must be at least ${processConfig.minHeight}px.`, code: 'minHeight' });
                }
                if (data.width < toInteger(processConfig.minWidth)) {
                    return throwError({ error: `Width must be at least ${processConfig.minWidth}px.`, code: 'minWidth' });
                }
                return of(fsFile);
            }));
        }
        return of(fsFile);
    }
    _transformHeic(fsFile) {
        if (fsFile.isExtension(['heic', 'heif']) && fsFile.file instanceof Blob) {
            return from(heic2any({ blob: fsFile.file, multiple: true, toType: 'image/jpeg' }))
                .pipe(map((blob) => {
                const ext = blob.type?.split('/') || [];
                const name = fsFile.name.replace(/(heic|heif)$/i, ext[1] || 'jpg');
                return new FsFile(blob[0], name);
            }));
        }
        return of(fsFile);
    }
    _transform(fsFile, processConfig) {
        return this._transformHeic(fsFile)
            .pipe(switchMap((response) => this._transformImage(response, processConfig)));
    }
    _transformImage(fsFile, processConfig) {
        if (fsFile.imageProcess) {
            return of(fsFile);
        }
        if (!processConfig.orientate &&
            !processConfig.maxWidth &&
            !processConfig.maxHeight &&
            processConfig.quality === 1) {
            return of(fsFile);
        }
        return from(fsFile.exifInfo)
            .pipe(switchMap((exifInfo) => {
            if (!exifInfo?.Orientation) {
                return of(fsFile);
            }
            return new Observable((observer) => {
                const transformConfig = this._generateTransformConfig(fsFile, processConfig);
                // Transform image by options and rotate if needed
                FileAPI.Image.transform(fsFile.file, [transformConfig], processConfig.orientate, (err, images) => {
                    // Process transformed files
                    if (!err && images[0]) {
                        const canvas = images[0];
                        const type = (processConfig.format) ? `image/${processConfig.format}` : fsFile.type;
                        canvas.toBlob((blob) => {
                            fsFile.file = new File([blob], fsFile.file.name, { type: fsFile.type });
                            observer.next(fsFile);
                            observer.complete();
                        }, type, processConfig.quality);
                    }
                    else {
                        observer.error(err);
                    }
                });
            });
        }));
    }
    _generateTransformConfig(file, config) {
        return {
            // Resize
            maxWidth: config.maxWidth,
            maxHeight: config.maxHeight,
            // Quality for result image
            quality: config.quality || 1,
        };
    }
}

class FileClickHandler {
    constructor(_next, _interceptor) {
        this._next = _next;
        this._interceptor = _interceptor;
    }
    handle(event, inputProcessorService) {
        return this._interceptor.intercept(event, inputProcessorService, this._next);
    }
}

class FileClickInterceptor {
}

const FS_FILE_MODULE_CONFIG = new InjectionToken('fs-file.module-config');

const FS_FILE_CLICK_INTERCEPTOR = new InjectionToken('fs-file-click-interceptor');

class ClickInterceptor extends FileClickInterceptor {
    intercept(event, inputProcessorService, next) {
        inputProcessorService.inputEl.click();
        return of(null);
    }
}

class InputProcessorService {
    constructor(_clickInterceptors) {
        this._clickInterceptors = _clickInterceptors;
        this.multiple = false;
        this.api = null;
        this.allowClick = true;
        this.allowDrop = true;
        this.select = new EventEmitter();
        this.clicked = new EventEmitter();
        this._accept = '*';
        this._acceptableTypes = new Map();
        this._acceptableExts = new Set();
        this._declinedFiles$ = new Subject();
    }
    get accept() {
        return this._accept;
    }
    set accept(value) {
        value = value || '*';
        this._acceptableTypes.clear();
        this._acceptableExts.clear();
        this._parseAcceptTypes(value);
        this._accept = [
            ...Array.from(this._acceptableTypes)
                .reduce((accum, [key, values]) => {
                return [
                    ...accum,
                    ...Array.from(values)
                        .map((item) => `${key}/${item}`),
                ];
            }, []),
            ...Array.from(this._acceptableExts).values(),
        ].join(',');
    }
    get declinedFiles$() {
        return this._declinedFiles$.asObservable();
    }
    /**
     * Initialize service for target element
     *
     * @param el
     */
    registerInput(el) {
        if (!el) {
            return;
        }
        this.inputEl = el.nativeElement;
        FileAPI.event.on(this.inputEl, 'change', (event) => {
            if (!this.allowClick) {
                return;
            }
            const files = FileAPI.getFiles(event);
            if (files) {
                this.selectFiles(files);
            }
            this.inputEl.value = null;
        });
    }
    registerDrop(el) {
        if (!el) {
            return;
        }
        this.containerEl = el.nativeElement;
        FileAPI.event.on(this.containerEl, 'drop', (event) => {
            if (!this.allowDrop) {
                return;
            }
            const files = FileAPI.getFiles(event);
            if (files) {
                this.selectFiles(files);
            }
            this.inputEl.value = null;
        });
    }
    registerLabel(el) {
        if (!el) {
            return;
        }
        FileAPI.event.on(el.nativeElement, 'click', (event) => {
            if (!this.allowClick) {
                return;
            }
            if (!event.defaultPrevented) {
                this.clicked.next(event);
                const interceptors = [
                    ...this._clickInterceptors || [],
                    new ClickInterceptor(),
                ];
                const interceptorChain = interceptors.reduceRight((next, interceptor) => new FileClickHandler(next, interceptor), null);
                interceptorChain.handle(event, this)
                    .subscribe();
            }
        });
    }
    isAcceptVideo() {
        return this.accept.match(/video/i) || this.accept === '*';
    }
    isAcceptImage() {
        return this.accept.match(/image/i) || this.accept === '*';
    }
    selectFiles(files) {
        const declinedFiles = [];
        const fsFiles = files
            .map((file) => new FsFile(file))
            .filter((file) => {
            const nameParts = file.name.split('.');
            let ext;
            if (nameParts && Array.isArray(nameParts)) {
                ext = nameParts[nameParts.length - 1];
            }
            ext = (`${ext}`).toLowerCase();
            const acceptableFile = this._checkAcceptableTypes(file.type, ext);
            if (!acceptableFile) {
                declinedFiles.push(file);
            }
            return acceptableFile;
        });
        if (declinedFiles.length > 0) {
            this._declinedFiles$.next(declinedFiles);
        }
        if (fsFiles.length > 0) {
            if (this.multiple) {
                this.select.emit(fsFiles);
            }
            else {
                this.select.emit(fsFiles[0]);
            }
        }
    }
    /**
     * Check if file mimetype or extention is acceptable by @accept field
     *
     * @param targetType
     * @param targetExt
     * @returns boolean
     */
    _checkAcceptableTypes(targetType, targetExt) {
        targetType = targetType.trim();
        const [type, ext] = targetType.split('/');
        const acceptableType = this._acceptableTypes.get(type);
        return this.accept === '*'
            || this.accept === '*/*'
            || (!!acceptableType && (acceptableType.has('*') || acceptableType.has(ext)))
            || this._acceptableExts.has(`.${targetExt}`);
    }
    /**
     * Parset and store acceptable types for feature filter
     *
     * @param types
     */
    _parseAcceptTypes(value) {
        let types = [];
        if (typeof value === 'string') {
            types = value.split(/[,;]/);
        }
        if (!types.length) {
            return;
        }
        types = types
            .map((type) => type.trim());
        types.forEach((part) => {
            if (part === '*') {
                this._acceptableExts.add('*');
            }
            else if (part.indexOf('/') !== -1) {
                const [type, ext] = part.split('/');
                if (this._acceptableTypes.has(type)) {
                    const existedType = this._acceptableTypes.get(type);
                    if (!existedType.has(ext)) {
                        existedType.add(ext);
                    }
                }
                else {
                    const extensions = new Set();
                    this._acceptableTypes.set(type, extensions);
                    extensions.add(ext);
                }
            }
            else if (part.indexOf('.') !== -1) {
                part = part.replace(/^\*/, '');
                if (!this._acceptableExts.has(part)) {
                    this._acceptableExts.add(part);
                }
            }
            else if (part.match(/[a-z0-9]{3,4}/i)) {
                if (!this._acceptableExts.has(part)) {
                    this._acceptableExts.add(`.${part}`);
                }
            }
        });
        const imageType = this._acceptableTypes.get('image');
        if (imageType?.has('*')) {
            this._acceptableExts.add('.heic');
            this._acceptableExts.add('.heif');
        }
    }
}
InputProcessorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InputProcessorService, deps: [{ token: FS_FILE_CLICK_INTERCEPTOR, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
InputProcessorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InputProcessorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InputProcessorService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FS_FILE_CLICK_INTERCEPTOR]
                }] }]; } });

class FsFileComponent extends FsFileDragBaseComponent {
    constructor(el, inputProcessor, moduleConfig, _message) {
        super();
        this.el = el;
        this.inputProcessor = inputProcessor;
        this.moduleConfig = moduleConfig;
        this._message = _message;
        this.select = new EventEmitter();
        this.error = new EventEmitter();
        this.beforeProcessing = new EventEmitter();
        this.clicked = new EventEmitter();
        this.declined = new EventEmitter();
        this._destroy$ = new Subject();
        this._processConfig = new FileProcessConfig();
        this._initSelect();
    }
    set minHeight(value) {
        this._processConfig.minHeight = value;
    }
    set minWidth(value) {
        this._processConfig.minWidth = value;
    }
    set orientate(value) {
        this._processConfig.orientate = value;
    }
    set multiple(value) {
        // TODO This should be a helper function in @firestitch/common
        this.inputProcessor.multiple = typeof (value) === 'boolean' ? value : value === 'true';
    }
    get multiple() {
        return this.inputProcessor.multiple;
    }
    get api() {
        return this.inputProcessor.api;
    }
    set capture(value) {
        this.inputProcessor.capture = value;
    }
    get capture() {
        return this.inputProcessor.capture;
    }
    set allowClick(value) {
        this.inputProcessor.allowClick = value;
    }
    set allowDrop(value) {
        this.inputProcessor.allowDrop = value;
    }
    /**
     * Accept Examples
     *
     * image/*,audio/*,video/*,image/jpg,.pdf
     */
    set accept(value) {
        this.inputProcessor.accept = Array.isArray(value) ? value.join(',') : value;
    }
    get accept() {
        return this.inputProcessor.accept;
    }
    set disabled(value) {
        this.inputProcessor.disabled = value;
    }
    get disabled() {
        return this.inputProcessor.disabled;
    }
    set imageWidth(value) {
        this._processConfig.maxWidth = +value;
    }
    set imageHeight(value) {
        this._processConfig.maxHeight = +value;
    }
    set imageQuality(value) {
        this._processConfig.quality = value;
    }
    ngOnInit() {
        this.inputProcessor.registerInput(this.fileInput);
        this.inputProcessor.registerLabel(this.fileContainer);
        this.inputProcessor.registerDrop(this.el);
        this._listenDeclinedFiles();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    _initSelect() {
        const fileProcessor = new FileProcessor();
        this.inputProcessor.clicked
            .pipe(takeUntil(this._destroy$))
            .subscribe((event) => {
            this.clicked.next(event);
        });
        this.inputProcessor.select
            .pipe(map((files) => {
            return Array.isArray(files) ? files : [files];
        }), tap((files) => {
            this.beforeProcessing.emit(files);
        }), switchMap((files) => {
            return fileProcessor.processFiles(files, this._processConfig);
        }), map((fsFiles) => {
            return this.inputProcessor.multiple ? fsFiles : fsFiles[0];
        }), tap((e) => {
            this.select.emit(e);
        }), catchError((e) => {
            this.error.emit(e);
            this._initSelect();
            return of(null);
        }), takeUntil(this._destroy$))
            .subscribe();
    }
    _listenDeclinedFiles() {
        this.inputProcessor
            .declinedFiles$
            .pipe(takeUntil(this._destroy$))
            .subscribe((files) => {
            this.declined.next(files);
            files.forEach((file) => {
                this._message.error(`Upload file type is not supported for ${file.name}`, {
                    mode: MessageMode.Toast,
                    positionClass: 'toast-bottom-right',
                });
            });
        });
    }
}
FsFileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileComponent, deps: [{ token: i0.ElementRef }, { token: InputProcessorService }, { token: FS_FILE_MODULE_CONFIG, optional: true }, { token: i2$1.FsMessage }], target: i0.ɵɵFactoryTarget.Component });
FsFileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFileComponent, selector: "fs-file", inputs: { minHeight: "minHeight", minWidth: "minWidth", orientate: "orientate", multiple: "multiple", capture: "capture", allowClick: "allowClick", allowDrop: "allowDrop", accept: "accept", disabled: "disabled", imageWidth: "imageWidth", imageHeight: "imageHeight", imageQuality: "imageQuality" }, outputs: { select: "select", error: "error", beforeProcessing: "beforeProcessing", clicked: "clicked", declined: "declined" }, providers: [InputProcessorService], viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true, static: true }, { propertyName: "fileContainer", first: true, predicate: ["fileContainer"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<span class=\"file-container\" #fileContainer>\n  <ng-content></ng-content>\n</span>\n<input\n  #fileInput\n  type=\"file\"\n  [hidden]=\"true\"\n  [disabled]=\"inputProcessor.disabled\"\n  [multiple]=\"inputProcessor.multiple\"\n  [attr.accept]=\"inputProcessor.accept\"\n  [attr.capture]=\"inputProcessor.capture\">\n\n<fs-file-dragover-message *ngIf=\"moduleConfig.dragoverMessage\"></fs-file-dragover-message>\n", styles: [".file-container{cursor:pointer;display:inline-flex}\n"], components: [{ type: FsFileDragoverMessageComponent, selector: "fs-file-dragover-message" }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-file', changeDetection: ChangeDetectionStrategy.OnPush, providers: [InputProcessorService], template: "<span class=\"file-container\" #fileContainer>\n  <ng-content></ng-content>\n</span>\n<input\n  #fileInput\n  type=\"file\"\n  [hidden]=\"true\"\n  [disabled]=\"inputProcessor.disabled\"\n  [multiple]=\"inputProcessor.multiple\"\n  [attr.accept]=\"inputProcessor.accept\"\n  [attr.capture]=\"inputProcessor.capture\">\n\n<fs-file-dragover-message *ngIf=\"moduleConfig.dragoverMessage\"></fs-file-dragover-message>\n", styles: [".file-container{cursor:pointer;display:inline-flex}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: InputProcessorService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FS_FILE_MODULE_CONFIG]
                }] }, { type: i2$1.FsMessage }]; }, propDecorators: { select: [{
                type: Output
            }], error: [{
                type: Output
            }], beforeProcessing: [{
                type: Output
            }], clicked: [{
                type: Output
            }], declined: [{
                type: Output
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput', { static: true }]
            }], fileContainer: [{
                type: ViewChild,
                args: ['fileContainer', { static: true }]
            }], minHeight: [{
                type: Input
            }], minWidth: [{
                type: Input
            }], orientate: [{
                type: Input
            }], multiple: [{
                type: Input
            }], capture: [{
                type: Input
            }], allowClick: [{
                type: Input
            }], allowDrop: [{
                type: Input
            }], accept: [{
                type: Input
            }], disabled: [{
                type: Input
            }], imageWidth: [{
                type: Input
            }], imageHeight: [{
                type: Input
            }], imageQuality: [{
                type: Input
            }] } });

class FsFileSrcPipe {
    constructor(_domSanitizer) {
        this._domSanitizer = _domSanitizer;
    }
    transform(file) {
        return of(null)
            .pipe(switchMap(() => {
            const data = this._getData(file);
            if (typeof data === 'string') {
                return of(data);
            }
            if (data instanceof FsApiFile || data instanceof Blob) {
                return of(null)
                    .pipe(switchMap(() => {
                    return data instanceof FsApiFile ? data.blob : of(data);
                }), map((data) => {
                    return this._domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
                }));
            }
            return throwError('Invalid file type');
        }));
    }
    _getData(file) {
        if (file instanceof FsFile) {
            if (file.apiFile) {
                return file.apiFile;
            }
            return file.url ? file.url : file.file;
        }
        if (file instanceof Blob || file instanceof File) {
            return file;
        }
        return null;
    }
}
FsFileSrcPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileSrcPipe, deps: [{ token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
FsFileSrcPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileSrcPipe, name: "fsFileSrc" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileSrcPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'fsFileSrc' }]
        }], ctorParameters: function () { return [{ type: i1$1.DomSanitizer }]; } });

class FsFileImagePickerComponent {
    constructor(_dialog, _cdRef) {
        this._dialog = _dialog;
        this._cdRef = _cdRef;
        this.borderRadius = '100%';
        this.previewDiameter = 80;
        this.previewFit = 'cover';
        this.label = '';
        this.minWidth = 0;
        this.minHeight = 0;
        this.disabled = false;
        this.select = new EventEmitter();
        this.error = new EventEmitter();
        this.selectUrl = new EventEmitter();
        this.processing = false;
    }
    set url(url) {
        this._previousFile = this._file;
        this._file = url ? new FsFile(url) : null;
    }
    get file() {
        return this._file;
    }
    beforeProcessing(fsFiles) {
        this.processing = true;
    }
    selectFile(file) {
        this._previousFile = this._file;
        this._file = file;
        this.processing = false;
        setTimeout(() => {
            this.select.emit(file);
        });
    }
    cancel() {
        this._file = this._previousFile;
        this._previousFile = null;
        this._cdRef.markForCheck();
    }
    clicked(event) {
        if (this.disabled) {
            return;
        }
        if (event.shiftKey) {
            event.preventDefault();
            this._dialog.open(FsFileImagePickerDialogComponent, {
                data: {
                    file: this._file,
                    selectUrl: this.selectUrl
                },
                width: '500px',
                autoFocus: false
            });
        }
    }
}
FsFileImagePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileImagePickerComponent, deps: [{ token: i3$1.MatDialog }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsFileImagePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFileImagePickerComponent, selector: "fs-file-image-picker", inputs: { imageQuality: "imageQuality", borderRadius: "borderRadius", imageWidth: "imageWidth", imageHeight: "imageHeight", previewDiameter: "previewDiameter", previewFit: "previewFit", label: "label", minWidth: "minWidth", minHeight: "minHeight", disabled: "disabled", url: "url" }, outputs: { select: "select", error: "error", selectUrl: "selectUrl" }, queries: [{ propertyName: "labelTemplate", first: true, predicate: FsFileLabelDirective, descendants: true, read: TemplateRef }, { propertyName: "hintTemplate", first: true, predicate: FsFileHintDirective, descendants: true, read: TemplateRef }], ngImport: i0, template: "\n\n<ng-container *ngIf=\"labelTemplate || hintTemplate || label; else preview\">\n  <fs-label-field class=\"fs-image-label\">\n    <fs-label *ngIf=\"labelTemplate || label\">\n      {{ label }}\n      <ng-container *ngTemplateOutlet=\"labelTemplate\"></ng-container>\n    </fs-label>\n    <ng-container *ngTemplateOutlet=\"preview\"></ng-container>\n    <fs-label-message class=\"fs-form-message\">\n      <span class=\"fs-form-hint\">\n        <ng-container *ngTemplateOutlet=\"hintTemplate\"></ng-container>\n      </span>\n    </fs-label-message>\n  </fs-label-field>\n</ng-container>\n\n<ng-template #preview>\n  <div \n    class=\"wrap\" \n    [ngClass]=\"{ \n      disabled: disabled, \n      processing: processing,\n      exists: file?.exists && file.typeImage \n    }\">\n    <ng-container *ngIf=\"processing\">\n      <mat-spinner [diameter]=\"previewDiameter * .25\"></mat-spinner>\n    </ng-container>\n    <fs-file\n        *ngIf=\"!disabled; else filePreview\"\n        (select)=\"selectFile($event)\"\n        (beforeProcessing)=\"beforeProcessing($event)\"\n        (error)=\"error.emit($event)\"\n        (clicked)=\"clicked($event)\"\n        [minHeight]=\"minHeight\"\n        [minWidth]=\"minWidth\"\n        [imageWidth]=\"imageWidth\"\n        [imageHeight]=\"imageHeight\"\n        [imageQuality]=\"imageQuality\"\n        [disabled]=\"disabled\"\n        accept=\"image/*\"\n        [multiple]=\"false\">\n      <ng-container *ngTemplateOutlet=\"filePreview\"></ng-container>\n    </fs-file>\n  </div>\n\n  <ng-template #filePreview>\n    <div \n        class=\"image-preview\"\n        [style.borderRadius]=\"borderRadius\"\n        [style.height]=\"previewDiameter + 'px'\"\n        [style.width]=\"previewDiameter + 'px'\">\n      <ng-container \n        *ngIf=\"file?.exists && file.typeImage; else noImage\">\n        <ng-container *ngIf=\"(file | fsFileSrc | async) as src\">\n          <img \n            [style.borderRadius]=\"borderRadius\"\n            [src]=\"src\">\n        </ng-container>\n      </ng-container>\n      <ng-template #noImage>\n        <div class=\"no-image\">\n          <mat-icon\n              [style.transform]=\"'scale(' + ((previewDiameter / 50) * 100) + '%)'\">\n            image\n          </mat-icon>\n        </div>\n      </ng-template>\n      <div \n          [style.transform]=\"'rotate(46deg) translate(' + (previewDiameter - 1) + 'px) rotate(-46deg)'\"\n          class=\"upload-icon\">\n        <button \n            mat-mini-fab\n            type=\"button\"\n            [style.margin]=\"(previewDiameter < 100 ? (1 - (previewDiameter / 100)) * -10 : 1) + 'px'\"\n            [style.transform]=\"'scale(' + (previewDiameter < 100 ? (previewDiameter / 100) : 1) + ')'\">\n          <mat-icon>\n              photo_camera\n          </mat-icon>\n        </button>\n      </div>\n    </div>\n  </ng-template>\n</ng-template>\n", styles: [".fs-image-label{min-height:1px}.wrap{position:relative;display:inline-flex}.wrap:not(.disabled){cursor:pointer}.wrap.disabled .upload-icon{display:none}.wrap.processing mat-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1}.wrap.processing .image-preview{opacity:.5}.image-preview{position:relative;display:flex;align-items:center;justify-content:center;border:1px solid transparent;box-sizing:content-box}.image-preview .upload-icon{position:absolute;display:block;top:11%;left:11%;margin:-13px}.image-preview .upload-icon mat-icon{color:#e9e9e9}.image-preview .no-image{display:flex}.image-preview .no-image mat-icon{color:#ececec}.image-preview img{display:block;object-fit:cover;width:100%;height:100%}\n"], components: [{ type: i1.FsLabelFieldComponent, selector: "fs-label-field", inputs: ["bottomMargin", "topMargin", "labelMargin"] }, { type: i1.FsLabelComponent, selector: "fs-label" }, { type: i1.FsLabelMessageComponent, selector: "fs-label-message" }, { type: i3$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { type: FsFileComponent, selector: "fs-file", inputs: ["minHeight", "minWidth", "orientate", "multiple", "capture", "allowClick", "allowDrop", "accept", "disabled", "imageWidth", "imageHeight", "imageQuality"], outputs: ["select", "error", "beforeProcessing", "clicked", "declined"] }, { type: i5.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "async": i3.AsyncPipe, "fsFileSrc": FsFileSrcPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileImagePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-file-image-picker', changeDetection: ChangeDetectionStrategy.OnPush, template: "\n\n<ng-container *ngIf=\"labelTemplate || hintTemplate || label; else preview\">\n  <fs-label-field class=\"fs-image-label\">\n    <fs-label *ngIf=\"labelTemplate || label\">\n      {{ label }}\n      <ng-container *ngTemplateOutlet=\"labelTemplate\"></ng-container>\n    </fs-label>\n    <ng-container *ngTemplateOutlet=\"preview\"></ng-container>\n    <fs-label-message class=\"fs-form-message\">\n      <span class=\"fs-form-hint\">\n        <ng-container *ngTemplateOutlet=\"hintTemplate\"></ng-container>\n      </span>\n    </fs-label-message>\n  </fs-label-field>\n</ng-container>\n\n<ng-template #preview>\n  <div \n    class=\"wrap\" \n    [ngClass]=\"{ \n      disabled: disabled, \n      processing: processing,\n      exists: file?.exists && file.typeImage \n    }\">\n    <ng-container *ngIf=\"processing\">\n      <mat-spinner [diameter]=\"previewDiameter * .25\"></mat-spinner>\n    </ng-container>\n    <fs-file\n        *ngIf=\"!disabled; else filePreview\"\n        (select)=\"selectFile($event)\"\n        (beforeProcessing)=\"beforeProcessing($event)\"\n        (error)=\"error.emit($event)\"\n        (clicked)=\"clicked($event)\"\n        [minHeight]=\"minHeight\"\n        [minWidth]=\"minWidth\"\n        [imageWidth]=\"imageWidth\"\n        [imageHeight]=\"imageHeight\"\n        [imageQuality]=\"imageQuality\"\n        [disabled]=\"disabled\"\n        accept=\"image/*\"\n        [multiple]=\"false\">\n      <ng-container *ngTemplateOutlet=\"filePreview\"></ng-container>\n    </fs-file>\n  </div>\n\n  <ng-template #filePreview>\n    <div \n        class=\"image-preview\"\n        [style.borderRadius]=\"borderRadius\"\n        [style.height]=\"previewDiameter + 'px'\"\n        [style.width]=\"previewDiameter + 'px'\">\n      <ng-container \n        *ngIf=\"file?.exists && file.typeImage; else noImage\">\n        <ng-container *ngIf=\"(file | fsFileSrc | async) as src\">\n          <img \n            [style.borderRadius]=\"borderRadius\"\n            [src]=\"src\">\n        </ng-container>\n      </ng-container>\n      <ng-template #noImage>\n        <div class=\"no-image\">\n          <mat-icon\n              [style.transform]=\"'scale(' + ((previewDiameter / 50) * 100) + '%)'\">\n            image\n          </mat-icon>\n        </div>\n      </ng-template>\n      <div \n          [style.transform]=\"'rotate(46deg) translate(' + (previewDiameter - 1) + 'px) rotate(-46deg)'\"\n          class=\"upload-icon\">\n        <button \n            mat-mini-fab\n            type=\"button\"\n            [style.margin]=\"(previewDiameter < 100 ? (1 - (previewDiameter / 100)) * -10 : 1) + 'px'\"\n            [style.transform]=\"'scale(' + (previewDiameter < 100 ? (previewDiameter / 100) : 1) + ')'\">\n          <mat-icon>\n              photo_camera\n          </mat-icon>\n        </button>\n      </div>\n    </div>\n  </ng-template>\n</ng-template>\n", styles: [".fs-image-label{min-height:1px}.wrap{position:relative;display:inline-flex}.wrap:not(.disabled){cursor:pointer}.wrap.disabled .upload-icon{display:none}.wrap.processing mat-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1}.wrap.processing .image-preview{opacity:.5}.image-preview{position:relative;display:flex;align-items:center;justify-content:center;border:1px solid transparent;box-sizing:content-box}.image-preview .upload-icon{position:absolute;display:block;top:11%;left:11%;margin:-13px}.image-preview .upload-icon mat-icon{color:#e9e9e9}.image-preview .no-image{display:flex}.image-preview .no-image mat-icon{color:#ececec}.image-preview img{display:block;object-fit:cover;width:100%;height:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i3$1.MatDialog }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { labelTemplate: [{
                type: ContentChild,
                args: [FsFileLabelDirective, { read: TemplateRef }]
            }], hintTemplate: [{
                type: ContentChild,
                args: [FsFileHintDirective, { read: TemplateRef }]
            }], imageQuality: [{
                type: Input
            }], borderRadius: [{
                type: Input
            }], imageWidth: [{
                type: Input
            }], imageHeight: [{
                type: Input
            }], previewDiameter: [{
                type: Input
            }], previewFit: [{
                type: Input
            }], label: [{
                type: Input
            }], minWidth: [{
                type: Input
            }], minHeight: [{
                type: Input
            }], disabled: [{
                type: Input
            }], url: [{
                type: Input,
                args: ['url']
            }], select: [{
                type: Output
            }], error: [{
                type: Output
            }], selectUrl: [{
                type: Output
            }] } });

class FsFilePreviewComponent {
    constructor() {
        this.previewActions = [];
        this.showFilename = true;
        this.previewWidth = 150;
        this.previewHeight = 150;
        this.showActionOn = 'hover';
        this.remove = new EventEmitter();
        this.loaded = false;
        this.iconDim = 100;
        this.extensionFontSize = 20;
    }
    get typeImage() {
        return this.file?.typeImage && this.file?.exists;
    }
    ngOnInit() {
        if (this.url) {
            this.file = new FsFile(this.url);
        }
        this.previewHeight = this.previewHeight || 150;
        this.previewWidth = this.previewWidth || 150;
        const iconDim = this.previewWidth * .7;
        if (iconDim < 100) {
            this.iconDim = iconDim;
            this.extensionFontSize = this.extensionFontSize * (iconDim / 100);
        }
    }
    ngOnChanges(changes) {
        if (changes.file) {
            this.loaded = false;
        }
    }
    ngAfterContentInit() {
        this._cleanActions();
    }
    previewLoaded() {
        this.loaded = true;
    }
    previewError() {
        this.loaded = true;
    }
    callAction($event, previewAction) {
        if (previewAction.click.observers.length) {
            $event.stopImmediatePropagation();
            $event.stopPropagation();
            previewAction.click.emit({ event: $event, file: this.file, index: this.index });
        }
        if (previewAction.action === 'remove') {
            this.remove.emit({ event: $event, file: this.file });
        }
    }
    _cleanActions() {
        this.previewActions
            .forEach((action) => {
            if (action.forTypes) {
                const [originalFileType, originalContentType] = this.file.type.split('/');
                const types = Array.isArray(action.forTypes) ?
                    action.forTypes :
                    [action.forTypes];
                action.hide = types
                    .some((type) => {
                    const [fileType, contentType] = type.split('/');
                    const allowed = fileType === originalFileType &&
                        (contentType === originalContentType || contentType === '*');
                    return !allowed;
                });
            }
        });
    }
}
FsFilePreviewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePreviewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsFilePreviewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFilePreviewComponent, selector: "fs-file-preview", inputs: { previewActions: "previewActions", showFilename: "showFilename", previewWidth: "previewWidth", previewHeight: "previewHeight", file: "file", url: "url", index: "index", showActionOn: "showActionOn" }, outputs: { remove: "remove" }, queries: [{ propertyName: "childrenPreviewActions", predicate: FsFilePreviewActionDirective }], usesOnChanges: true, ngImport: i0, template: "<div\n    [style.width.px]=\"previewWidth\"\n    [style.height.px]=\"previewHeight\"\n    class=\"preview-container\"\n    [ngClass]=\"{ \n      'has-actions': (childrenPreviewActions.length !== 0 || previewActions.length !== 0),  \n      'type-image': typeImage,\n      'loaded': loaded,\n      'show-action-always': showActionOn === 'always'\n    }\">\n  <!-- Image container -->\n  <ng-container \n      *ngIf=\"typeImage; else nonImage\">\n    <ng-container *ngIf=\"(file | fsFileSrc | async) as src\">\n      <img \n        [src]=\"src\" \n        (load)=\"previewLoaded()\"\n        (error)=\"previewError()\">\n    </ng-container>\n   \n    <ng-container *ngIf=\"!loaded\">\n      <mat-spinner [diameter]=\"50\"></mat-spinner>\n    </ng-container>\n  </ng-container>\n\n  <!-- Non image container -->\n  <ng-template #nonImage>\n    <div class=\"file-details\">\n      <div class=\"file-icon\">\n        <div \n            class=\"file-ext\"\n            [style.fontSize]=\"extensionFontSize + 'px'\">\n          {{file.extension}}\n        </div>\n        <mat-icon \n          [style.width]=\"iconDim + 'px'\" \n          [style.height]=\"iconDim + 'px'\"\n          [style.fontSize]=\"iconDim + 'px'\">insert_drive_file</mat-icon>\n      </div>\n      <ng-container *ngIf=\"showFilename && file.name\">\n        <a \n            class=\"file-name\" \n            [matTooltip]=\"file.name\">\n          {{file.name}}\n        </a>\n      </ng-container>\n    </div>\n  </ng-template>\n\n  <div class=\"actions\">\n    <ng-container *ngFor=\"let previewAction of previewActions\">\n      <ng-container \n        [ngTemplateOutlet]=\"previewActionTmpl\" \n        [ngTemplateOutletContext]=\"{ previewAction: previewAction }\">\n      </ng-container>\n    </ng-container>\n    <ng-container *ngFor=\"let previewAction of childrenPreviewActions\">\n      <ng-container \n        [ngTemplateOutlet]=\"previewActionTmpl\" \n        [ngTemplateOutletContext]=\"{ previewAction: previewAction }\">\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <div class=\"spinner\">\n    <ng-container *ngIf=\"file.progress\">\n      <mat-spinner [diameter]=\"50\"></mat-spinner>\n    </ng-container>\n  </div>\n  <ng-content></ng-content>\n</div>\n\n<ng-template #previewActionTmpl let-previewAction=\"previewAction\">\n  <ng-container *ngIf=\"!previewAction.hide\">\n    <div\n        class=\"action mat-mini-fab mat-primary\"      \n        [class]=\"previewAction.placement\"\n        [matTooltip]=\"previewAction.tooltip\"\n        (click)=\"callAction($event, previewAction)\">\n      <span class=\"mat-button-wrapper\">\n        <ng-template [ngTemplateOutlet]=\"previewAction.templateRef\"></ng-template>\n      </span>\n    </div>\n  </ng-container>\n</ng-template>", styles: [":host{border:1px #efefef solid;display:inline-block;position:relative;vertical-align:top;overflow:hidden;border-radius:3px}:host .file-details{flex-direction:column;display:flex;padding:5px;min-width:0}:host .file-details .file-icon{position:relative;display:flex;justify-content:center}:host .file-details .file-ext{font-weight:700;text-align:center;text-transform:uppercase;font-size:20px;position:absolute;width:100%;bottom:25%;color:#fff}:host .file-details mat-icon{color:#ccc}:host .file-details .file-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:5px;font-size:75%;text-align:center;width:100%;color:inherit;box-sizing:border-box}:host .preview-container.show-action-always .actions .action.top-left,:host .preview-container:hover .actions .action.top-left,:host .preview-container:focus .actions .action.top-left{top:8px;left:8px}:host .preview-container.show-action-always .actions .action.top-right,:host .preview-container:hover .actions .action.top-right,:host .preview-container:focus .actions .action.top-right{top:8px;right:8px}:host .preview-container.show-action-always .actions .action.bottom-left,:host .preview-container:hover .actions .action.bottom-left,:host .preview-container:focus .actions .action.bottom-left{bottom:8px;left:8px}:host .preview-container.show-action-always .actions .action.bottom-right,:host .preview-container:hover .actions .action.bottom-right,:host .preview-container:focus .actions .action.bottom-right{bottom:8px;right:8px}:host .preview-container{overflow:hidden;box-sizing:border-box;margin:auto;display:flex;align-items:center;flex-grow:1;height:100%;justify-content:center}:host .preview-container.type-image{background-image:linear-gradient(to right,rgba(255,255,255,.75),rgba(255,255,255,.75)),linear-gradient(to right,black 50%,white 50%),linear-gradient(to bottom,black 50%,white 50%);background-blend-mode:normal,difference,normal;background-size:20px 20px}:host .preview-container.type-image:not(.loaded){background:none}:host .preview-container.type-image:not(.loaded) .actions{display:none}:host .preview-container.loaded img{opacity:1}@media only screen and (max-width: 767.98px){:host .actions{display:block}}:host .actions .action.top-left{top:8px;left:8px}:host .actions .action.top-right{top:8px;right:8px}:host .actions .action.bottom-left{bottom:8px;left:8px}:host .actions .action.bottom-right{bottom:8px;right:8px}@media only screen and (min-width: 768px){:host .actions .action.top-left,:host .actions .action.top-right,:host .actions .action.bottom-left,:host .actions .action.bottom-right{transition:top .3s,bottom .3s,left .3s,right .3s}:host .actions .action.top-left{top:-50px;left:-50px}:host .actions .action.top-right{top:-50px;right:-50px}:host .actions .action.bottom-left{bottom:-50px;left:-50px}:host .actions .action.bottom-right{bottom:-50px;right:-50px}}:host .actions .action{position:absolute;cursor:pointer}:host .actions .action.hide{display:none}:host:hover .actions,:host:focus .actions{display:block}:host img{display:block;transform:translateZ(.1px);object-position:top;object-fit:cover;width:100%;height:100%}:host .mat-button-wrapper{padding:0;line-height:15px!important}:host .spinner{position:absolute;top:50%;left:50%}img{opacity:0}mat-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}\n"], components: [{ type: i3$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { type: i5.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "async": i3.AsyncPipe, "fsFileSrc": FsFileSrcPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePreviewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-file-preview', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n    [style.width.px]=\"previewWidth\"\n    [style.height.px]=\"previewHeight\"\n    class=\"preview-container\"\n    [ngClass]=\"{ \n      'has-actions': (childrenPreviewActions.length !== 0 || previewActions.length !== 0),  \n      'type-image': typeImage,\n      'loaded': loaded,\n      'show-action-always': showActionOn === 'always'\n    }\">\n  <!-- Image container -->\n  <ng-container \n      *ngIf=\"typeImage; else nonImage\">\n    <ng-container *ngIf=\"(file | fsFileSrc | async) as src\">\n      <img \n        [src]=\"src\" \n        (load)=\"previewLoaded()\"\n        (error)=\"previewError()\">\n    </ng-container>\n   \n    <ng-container *ngIf=\"!loaded\">\n      <mat-spinner [diameter]=\"50\"></mat-spinner>\n    </ng-container>\n  </ng-container>\n\n  <!-- Non image container -->\n  <ng-template #nonImage>\n    <div class=\"file-details\">\n      <div class=\"file-icon\">\n        <div \n            class=\"file-ext\"\n            [style.fontSize]=\"extensionFontSize + 'px'\">\n          {{file.extension}}\n        </div>\n        <mat-icon \n          [style.width]=\"iconDim + 'px'\" \n          [style.height]=\"iconDim + 'px'\"\n          [style.fontSize]=\"iconDim + 'px'\">insert_drive_file</mat-icon>\n      </div>\n      <ng-container *ngIf=\"showFilename && file.name\">\n        <a \n            class=\"file-name\" \n            [matTooltip]=\"file.name\">\n          {{file.name}}\n        </a>\n      </ng-container>\n    </div>\n  </ng-template>\n\n  <div class=\"actions\">\n    <ng-container *ngFor=\"let previewAction of previewActions\">\n      <ng-container \n        [ngTemplateOutlet]=\"previewActionTmpl\" \n        [ngTemplateOutletContext]=\"{ previewAction: previewAction }\">\n      </ng-container>\n    </ng-container>\n    <ng-container *ngFor=\"let previewAction of childrenPreviewActions\">\n      <ng-container \n        [ngTemplateOutlet]=\"previewActionTmpl\" \n        [ngTemplateOutletContext]=\"{ previewAction: previewAction }\">\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <div class=\"spinner\">\n    <ng-container *ngIf=\"file.progress\">\n      <mat-spinner [diameter]=\"50\"></mat-spinner>\n    </ng-container>\n  </div>\n  <ng-content></ng-content>\n</div>\n\n<ng-template #previewActionTmpl let-previewAction=\"previewAction\">\n  <ng-container *ngIf=\"!previewAction.hide\">\n    <div\n        class=\"action mat-mini-fab mat-primary\"      \n        [class]=\"previewAction.placement\"\n        [matTooltip]=\"previewAction.tooltip\"\n        (click)=\"callAction($event, previewAction)\">\n      <span class=\"mat-button-wrapper\">\n        <ng-template [ngTemplateOutlet]=\"previewAction.templateRef\"></ng-template>\n      </span>\n    </div>\n  </ng-container>\n</ng-template>", styles: [":host{border:1px #efefef solid;display:inline-block;position:relative;vertical-align:top;overflow:hidden;border-radius:3px}:host .file-details{flex-direction:column;display:flex;padding:5px;min-width:0}:host .file-details .file-icon{position:relative;display:flex;justify-content:center}:host .file-details .file-ext{font-weight:700;text-align:center;text-transform:uppercase;font-size:20px;position:absolute;width:100%;bottom:25%;color:#fff}:host .file-details mat-icon{color:#ccc}:host .file-details .file-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:5px;font-size:75%;text-align:center;width:100%;color:inherit;box-sizing:border-box}:host .preview-container.show-action-always .actions .action.top-left,:host .preview-container:hover .actions .action.top-left,:host .preview-container:focus .actions .action.top-left{top:8px;left:8px}:host .preview-container.show-action-always .actions .action.top-right,:host .preview-container:hover .actions .action.top-right,:host .preview-container:focus .actions .action.top-right{top:8px;right:8px}:host .preview-container.show-action-always .actions .action.bottom-left,:host .preview-container:hover .actions .action.bottom-left,:host .preview-container:focus .actions .action.bottom-left{bottom:8px;left:8px}:host .preview-container.show-action-always .actions .action.bottom-right,:host .preview-container:hover .actions .action.bottom-right,:host .preview-container:focus .actions .action.bottom-right{bottom:8px;right:8px}:host .preview-container{overflow:hidden;box-sizing:border-box;margin:auto;display:flex;align-items:center;flex-grow:1;height:100%;justify-content:center}:host .preview-container.type-image{background-image:linear-gradient(to right,rgba(255,255,255,.75),rgba(255,255,255,.75)),linear-gradient(to right,black 50%,white 50%),linear-gradient(to bottom,black 50%,white 50%);background-blend-mode:normal,difference,normal;background-size:20px 20px}:host .preview-container.type-image:not(.loaded){background:none}:host .preview-container.type-image:not(.loaded) .actions{display:none}:host .preview-container.loaded img{opacity:1}@media only screen and (max-width: 767.98px){:host .actions{display:block}}:host .actions .action.top-left{top:8px;left:8px}:host .actions .action.top-right{top:8px;right:8px}:host .actions .action.bottom-left{bottom:8px;left:8px}:host .actions .action.bottom-right{bottom:8px;right:8px}@media only screen and (min-width: 768px){:host .actions .action.top-left,:host .actions .action.top-right,:host .actions .action.bottom-left,:host .actions .action.bottom-right{transition:top .3s,bottom .3s,left .3s,right .3s}:host .actions .action.top-left{top:-50px;left:-50px}:host .actions .action.top-right{top:-50px;right:-50px}:host .actions .action.bottom-left{bottom:-50px;left:-50px}:host .actions .action.bottom-right{bottom:-50px;right:-50px}}:host .actions .action{position:absolute;cursor:pointer}:host .actions .action.hide{display:none}:host:hover .actions,:host:focus .actions{display:block}:host img{display:block;transform:translateZ(.1px);object-position:top;object-fit:cover;width:100%;height:100%}:host .mat-button-wrapper{padding:0;line-height:15px!important}:host .spinner{position:absolute;top:50%;left:50%}img{opacity:0}mat-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}\n"] }]
        }], propDecorators: { childrenPreviewActions: [{
                type: ContentChildren,
                args: [FsFilePreviewActionDirective]
            }], previewActions: [{
                type: Input
            }], showFilename: [{
                type: Input
            }], previewWidth: [{
                type: Input
            }], previewHeight: [{
                type: Input
            }], file: [{
                type: Input
            }], url: [{
                type: Input
            }], index: [{
                type: Input
            }], showActionOn: [{
                type: Input
            }], remove: [{
                type: Output
            }] } });

class FsFilePickerComponent extends FsFileDragBaseComponent {
    constructor(_moduleConfig, _cdRef) {
        super();
        this._moduleConfig = _moduleConfig;
        this._cdRef = _cdRef;
        this.minWidth = 0;
        this.minHeight = 0;
        this.showFilename = true;
        this.allowDownload = false;
        this.allowReupload = true;
        this.multiple = false;
        this.allowRemove = false;
        this.select = new EventEmitter();
        this.remove = new EventEmitter();
        this.download = new EventEmitter();
        this.instruction = 'Drag & Drop your file or use the button below';
        this.processing = false;
        this._destroy$ = new Subject();
        this._previewWidth = '150px';
        this._previewHeight = '150px';
        this.onChange = () => {
            //
        };
        this.onTouch = () => {
            //
        };
    }
    set url(url) {
        this.file = url ? new FsFile(url) : null;
    }
    set file(file) {
        if (file instanceof FsApiFile) {
            this._file = new FsFile(file);
        }
        else if (file instanceof FsFile) {
            this._file = file;
        }
        else if (file) {
            this._file = new FsFile(file);
        }
        else {
            this._file = null;
        }
        this.previewFile = this._file;
    }
    get file() {
        return this._file;
    }
    set disabled(value) {
        this._disabled = value;
    }
    get disabled() {
        return this._disabled;
    }
    set previewWidth(value) {
        this._previewWidth = Number.isInteger(value) ? `${value}px` : value?.toString() || '';
    }
    get previewWidth() {
        return this._previewWidth;
    }
    set previewHeight(value) {
        this._previewHeight = Number.isInteger(value) ? `${value}px` : value?.toString() || '';
    }
    get previewHeight() {
        return this._previewHeight;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    ngOnInit() {
        if (this._moduleConfig) {
            if (this.allowDownload === undefined) {
                this.allowDownload = this._moduleConfig.allowDownload;
            }
            if (this.allowRemove === undefined) {
                this.allowRemove = this._moduleConfig.allowRemove;
            }
        }
    }
    validate(control) {
        if (this.file?.typeImage && (this.minWidth || this.minHeight)) {
            // if(this.file.imageWidth < this.minWidth) {
            //   return { minWidth: `Minimum width ${this.minWidth}px` };
            // }
            // if(this.file.imageHeight < this.minHeight) {
            //   return { minWidth: `Minimum height ${this.minHeight}px` };
            // }
        }
        return null;
    }
    get previewPercent() {
        return String(this._previewWidth).match(/%/);
    }
    clear() {
        this.file = null;
        this._cdRef.markForCheck();
    }
    writeValue(file) {
        this.file = file;
        this._cdRef.markForCheck();
    }
    beforeProcessing(fsFiles) {
        this.processing = true;
    }
    declined() {
        this.processing = false;
        this.file = null;
        this.previewFile = null;
        this.onChange(null);
        this._cdRef.markForCheck();
    }
    selectFile(fsFile) {
        if (!this.multiple) {
            this.file = fsFile;
            this.onChange(fsFile);
        }
        this.processing = false;
        this.select.emit(fsFile);
    }
    removeFile() {
        this.file = null;
        this.previewFile = null;
        this.remove.emit(this.file);
        this.onChange(null);
    }
    actionClick(event) {
        event.event.stopPropagation();
    }
    downloadClicked(event) {
        event.event.stopPropagation();
        if (this.download.observers.length) {
            event.event.preventDefault();
            this.download.emit(this.file);
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
FsFilePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePickerComponent, deps: [{ token: FS_FILE_MODULE_CONFIG, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsFilePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFilePickerComponent, selector: "fs-file-picker", inputs: { minWidth: "minWidth", minHeight: "minHeight", imageWidth: "imageWidth", imageHeight: "imageHeight", imageQuality: "imageQuality", label: "label", showFilename: "showFilename", allowDownload: "allowDownload", allowReupload: "allowReupload", multiple: "multiple", allowRemove: "allowRemove", url: "url", file: "file", accept: "accept", disabled: "disabled", previewWidth: "previewWidth", previewHeight: "previewHeight" }, outputs: { select: "select", remove: "remove", download: "download" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsFilePickerComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FsFilePickerComponent,
            multi: true,
        },
    ], queries: [{ propertyName: "filePickerSelectTemplate", first: true, predicate: FsFilePickerSelectDirective, descendants: true, read: TemplateRef }, { propertyName: "labels", predicate: FsFileLabelDirective }, { propertyName: "previewActions", predicate: FsFilePreviewActionDirective }], viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<fs-label-field\n    class=\"fs-form-wrapper\"\n    [ngClass]=\"{ 'percent-preview': previewPercent }\">\n  <ng-container *ngIf=\"label; else labelContent\">\n    <fs-label class=\"fs-form-label\">{{label}}</fs-label>\n  </ng-container>\n  <ng-template #labelContent>\n    <fs-label *ngIf=\"labels.length\" class=\"fs-form-label\">\n      <ng-content select=\"[fsFileLabel]\"></ng-content>\n    </fs-label>\n  </ng-template>\n  <fs-file\n      [accept]=\"accept\"\n      (select)=\"selectFile($event)\"\n      (declined)=\"declined()\"\n      (beforeProcessing)=\"beforeProcessing($event)\"\n      [imageWidth]=\"imageWidth\"\n      [imageHeight]=\"imageHeight\"\n      [imageQuality]=\"imageQuality\"\n      [disabled]=\"disabled\"\n      [multiple]=\"multiple\">\n    <div\n        class=\"wrap\"\n        [style.width]=\"previewWidth\"\n        [style.height]=\"previewHeight\"\n        [ngClass]=\"{ processing: processing }\">\n      <ng-container *ngIf=\"processing\">\n        <mat-spinner [diameter]=\"50\"></mat-spinner>\n      </ng-container>\n      <ng-container *ngIf=\"previewFile; else preview\">\n        <fs-file-preview\n            class=\"preview\"\n            (remove)=\"removeFile()\"\n            [file]=\"previewFile\"\n            [previewActions]=\"previewActions.toArray()\"\n            [showFilename]=\"showFilename\"\n            [previewHeight]=\"null\"\n            [previewWidth]=\"null\">\n          <ng-template\n              *ngIf=\"allowRemove\"\n              fs-file-preview-action\n              placement=\"top-right\"\n              action=\"remove\"\n              tooltip=\"Remove\"\n              (click)=\"actionClick($event)\">\n            <mat-icon>close</mat-icon>\n          </ng-template>\n          <ng-template\n              *ngIf=\"allowReupload\"\n              fs-file-preview-action\n              action=\"reupload\"\n              placement=\"bottom-right\"\n              tooltip=\"Reupload\">\n            <mat-icon>upload</mat-icon>\n          </ng-template>\n          <ng-template\n              fs-file-preview-action\n              placement=\"bottom-left\"\n              action=\"download\"\n              tooltip=\"Download\"\n              [hide]=\"!(allowDownload && ((download.observers.length && file) || file?.url))\"\n              (click)=\"downloadClicked($event)\">\n            <a\n                [href]=\"previewFile.url\"\n                target=\"_blank\"\n                tabindex=\"-1\"\n                class=\"download\">\n              <mat-icon>download</mat-icon>\n            </a>\n          </ng-template>\n        </fs-file-preview>\n      </ng-container>\n      <ng-template #preview>\n        <ng-container *ngIf=\"filePickerSelectTemplate\">\n          <ng-container [ngTemplateOutlet]=\"filePickerSelectTemplate\"></ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"!filePickerSelectTemplate\">\n          <div class=\"select\">\n            <mat-icon>upload</mat-icon>\n            <div class=\"instruction\">{{instruction}}</div>\n            <div class=\"mat-raised-button\">Upload</div>\n          </div>\n        </ng-container>\n      </ng-template>\n    </div>\n  </fs-file>\n  <fs-label-message class=\"fs-form-message\">\n    <span class=\"fs-form-hint\">\n      <ng-content select=\"[fsFileHint]\"></ng-content>\n      <ng-content select=\"[fsFileMessageLabel]\"></ng-content>\n    </span>\n  </fs-label-message>\n</fs-label-field>\n", styles: [":host.dragover .wrap{border-color:transparent}:host.dragover .wrap:after{content:\"\";position:absolute;inset:0}:host.dragover .wrap .select{border:none}:host.dragover .select button{display:none}:host.dragover .select .mat-icon{color:#07a8e6}:host ::ng-deep .percent-preview fs-file .file-container,:host ::ng-deep .percent-preview fs-file-preview{display:block}:host ::ng-deep fs-file-preview{border:none;height:100%;width:100%}.wrap{border:1px #efefef solid;border-radius:3px}.wrap:after{border-width:3px;border-style:dashed;border-radius:3px}.wrap.processing .select{display:none}.wrap.processing mat-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1}.wrap .download{color:inherit}.wrap .select{text-align:center;width:100%;height:100%;vertical-align:middle;padding:0 10px;justify-content:center;flex-direction:column;box-sizing:border-box;display:flex;align-items:center}.wrap .select mat-icon{transform:scale(1.8);color:#ddd}.wrap .instruction{font-size:75%;padding:12px 0;line-height:normal}\n"], components: [{ type: i1.FsLabelFieldComponent, selector: "fs-label-field", inputs: ["bottomMargin", "topMargin", "labelMargin"] }, { type: i1.FsLabelComponent, selector: "fs-label" }, { type: FsFileComponent, selector: "fs-file", inputs: ["minHeight", "minWidth", "orientate", "multiple", "capture", "allowClick", "allowDrop", "accept", "disabled", "imageWidth", "imageHeight", "imageQuality"], outputs: ["select", "error", "beforeProcessing", "clicked", "declined"] }, { type: i3$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { type: FsFilePreviewComponent, selector: "fs-file-preview", inputs: ["previewActions", "showFilename", "previewWidth", "previewHeight", "file", "url", "index", "showActionOn"], outputs: ["remove"] }, { type: i5.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i1.FsLabelMessageComponent, selector: "fs-label-message" }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: FsFilePreviewActionDirective, selector: "[fs-file-preview-action]", inputs: ["placement", "tooltip", "action", "hide", "for-types"], outputs: ["click"] }, { type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-file-picker', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsFilePickerComponent),
                            multi: true,
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: FsFilePickerComponent,
                            multi: true,
                        },
                    ], template: "<fs-label-field\n    class=\"fs-form-wrapper\"\n    [ngClass]=\"{ 'percent-preview': previewPercent }\">\n  <ng-container *ngIf=\"label; else labelContent\">\n    <fs-label class=\"fs-form-label\">{{label}}</fs-label>\n  </ng-container>\n  <ng-template #labelContent>\n    <fs-label *ngIf=\"labels.length\" class=\"fs-form-label\">\n      <ng-content select=\"[fsFileLabel]\"></ng-content>\n    </fs-label>\n  </ng-template>\n  <fs-file\n      [accept]=\"accept\"\n      (select)=\"selectFile($event)\"\n      (declined)=\"declined()\"\n      (beforeProcessing)=\"beforeProcessing($event)\"\n      [imageWidth]=\"imageWidth\"\n      [imageHeight]=\"imageHeight\"\n      [imageQuality]=\"imageQuality\"\n      [disabled]=\"disabled\"\n      [multiple]=\"multiple\">\n    <div\n        class=\"wrap\"\n        [style.width]=\"previewWidth\"\n        [style.height]=\"previewHeight\"\n        [ngClass]=\"{ processing: processing }\">\n      <ng-container *ngIf=\"processing\">\n        <mat-spinner [diameter]=\"50\"></mat-spinner>\n      </ng-container>\n      <ng-container *ngIf=\"previewFile; else preview\">\n        <fs-file-preview\n            class=\"preview\"\n            (remove)=\"removeFile()\"\n            [file]=\"previewFile\"\n            [previewActions]=\"previewActions.toArray()\"\n            [showFilename]=\"showFilename\"\n            [previewHeight]=\"null\"\n            [previewWidth]=\"null\">\n          <ng-template\n              *ngIf=\"allowRemove\"\n              fs-file-preview-action\n              placement=\"top-right\"\n              action=\"remove\"\n              tooltip=\"Remove\"\n              (click)=\"actionClick($event)\">\n            <mat-icon>close</mat-icon>\n          </ng-template>\n          <ng-template\n              *ngIf=\"allowReupload\"\n              fs-file-preview-action\n              action=\"reupload\"\n              placement=\"bottom-right\"\n              tooltip=\"Reupload\">\n            <mat-icon>upload</mat-icon>\n          </ng-template>\n          <ng-template\n              fs-file-preview-action\n              placement=\"bottom-left\"\n              action=\"download\"\n              tooltip=\"Download\"\n              [hide]=\"!(allowDownload && ((download.observers.length && file) || file?.url))\"\n              (click)=\"downloadClicked($event)\">\n            <a\n                [href]=\"previewFile.url\"\n                target=\"_blank\"\n                tabindex=\"-1\"\n                class=\"download\">\n              <mat-icon>download</mat-icon>\n            </a>\n          </ng-template>\n        </fs-file-preview>\n      </ng-container>\n      <ng-template #preview>\n        <ng-container *ngIf=\"filePickerSelectTemplate\">\n          <ng-container [ngTemplateOutlet]=\"filePickerSelectTemplate\"></ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"!filePickerSelectTemplate\">\n          <div class=\"select\">\n            <mat-icon>upload</mat-icon>\n            <div class=\"instruction\">{{instruction}}</div>\n            <div class=\"mat-raised-button\">Upload</div>\n          </div>\n        </ng-container>\n      </ng-template>\n    </div>\n  </fs-file>\n  <fs-label-message class=\"fs-form-message\">\n    <span class=\"fs-form-hint\">\n      <ng-content select=\"[fsFileHint]\"></ng-content>\n      <ng-content select=\"[fsFileMessageLabel]\"></ng-content>\n    </span>\n  </fs-label-message>\n</fs-label-field>\n", styles: [":host.dragover .wrap{border-color:transparent}:host.dragover .wrap:after{content:\"\";position:absolute;inset:0}:host.dragover .wrap .select{border:none}:host.dragover .select button{display:none}:host.dragover .select .mat-icon{color:#07a8e6}:host ::ng-deep .percent-preview fs-file .file-container,:host ::ng-deep .percent-preview fs-file-preview{display:block}:host ::ng-deep fs-file-preview{border:none;height:100%;width:100%}.wrap{border:1px #efefef solid;border-radius:3px}.wrap:after{border-width:3px;border-style:dashed;border-radius:3px}.wrap.processing .select{display:none}.wrap.processing mat-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1}.wrap .download{color:inherit}.wrap .select{text-align:center;width:100%;height:100%;vertical-align:middle;padding:0 10px;justify-content:center;flex-direction:column;box-sizing:border-box;display:flex;align-items:center}.wrap .select mat-icon{transform:scale(1.8);color:#ddd}.wrap .instruction{font-size:75%;padding:12px 0;line-height:normal}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FS_FILE_MODULE_CONFIG]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { fileInput: [{
                type: ViewChild,
                args: ['fileInput']
            }], labels: [{
                type: ContentChildren,
                args: [FsFileLabelDirective]
            }], filePickerSelectTemplate: [{
                type: ContentChild,
                args: [FsFilePickerSelectDirective, { read: TemplateRef }]
            }], previewActions: [{
                type: ContentChildren,
                args: [FsFilePreviewActionDirective]
            }], minWidth: [{
                type: Input
            }], minHeight: [{
                type: Input
            }], imageWidth: [{
                type: Input
            }], imageHeight: [{
                type: Input
            }], imageQuality: [{
                type: Input
            }], label: [{
                type: Input
            }], showFilename: [{
                type: Input
            }], allowDownload: [{
                type: Input
            }], allowReupload: [{
                type: Input
            }], multiple: [{
                type: Input
            }], allowRemove: [{
                type: Input
            }], url: [{
                type: Input,
                args: ['url']
            }], file: [{
                type: Input,
                args: ['file']
            }], accept: [{
                type: Input
            }], disabled: [{
                type: Input
            }], previewWidth: [{
                type: Input
            }], previewHeight: [{
                type: Input
            }], select: [{
                type: Output
            }], remove: [{
                type: Output
            }], download: [{
                type: Output
            }] } });

class FilePreviewMapFilePipe {
    transform(file, mapFile) {
        if (mapFile) {
            return mapFile(file);
        }
        return file;
    }
}
FilePreviewMapFilePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FilePreviewMapFilePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FilePreviewMapFilePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FilePreviewMapFilePipe, name: "filePreviewMapFile" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FilePreviewMapFilePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'filePreviewMapFile' }]
        }] });

class FsFilePreviewsComponent {
    constructor() {
        this.previewWidth = 150;
        this.previewHeight = 150;
        this.showActionOn = 'hover';
        this.removed = new EventEmitter();
        this.queue = true;
    }
    removeFile(data) {
        const index = this.files.indexOf(data.file);
        if (index > -1) {
            this.files.splice(index, 1);
            this.removed.emit(this.files);
        }
    }
}
FsFilePreviewsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePreviewsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsFilePreviewsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsFilePreviewsComponent, selector: "fs-file-previews", inputs: { files: "files", mapFile: "mapFile", previewWidth: "previewWidth", previewHeight: "previewHeight", showActionOn: "showActionOn" }, outputs: { removed: "removed" }, host: { properties: { "class.queue": "this.queue" } }, queries: [{ propertyName: "previewActions", predicate: FsFilePreviewActionDirective }], ngImport: i0, template: "<ng-container *ngFor=\"let file of files; let index = index\">\n  <fs-file-preview  \n    [file]=\"file | filePreviewMapFile:mapFile\"\n    [previewWidth]=\"previewWidth\"\n    [previewActions]=\"previewActions.toArray()\"\n    [previewHeight]=\"previewHeight\"\n    [index]=\"index\"\n    [showActionOn]=\"showActionOn\"\n    (remove)=\"removeFile($event)\"\n    class=\"preview\">\n  </fs-file-preview>\n</ng-container>", components: [{ type: FsFilePreviewComponent, selector: "fs-file-preview", inputs: ["previewActions", "showFilename", "previewWidth", "previewHeight", "file", "url", "index", "showActionOn"], outputs: ["remove"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "filePreviewMapFile": FilePreviewMapFilePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFilePreviewsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-file-previews', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let file of files; let index = index\">\n  <fs-file-preview  \n    [file]=\"file | filePreviewMapFile:mapFile\"\n    [previewWidth]=\"previewWidth\"\n    [previewActions]=\"previewActions.toArray()\"\n    [previewHeight]=\"previewHeight\"\n    [index]=\"index\"\n    [showActionOn]=\"showActionOn\"\n    (remove)=\"removeFile($event)\"\n    class=\"preview\">\n  </fs-file-preview>\n</ng-container>" }]
        }], propDecorators: { previewActions: [{
                type: ContentChildren,
                args: [FsFilePreviewActionDirective]
            }], files: [{
                type: Input
            }], mapFile: [{
                type: Input
            }], previewWidth: [{
                type: Input
            }], previewHeight: [{
                type: Input
            }], showActionOn: [{
                type: Input
            }], removed: [{
                type: Output
            }], queue: [{
                type: HostBinding,
                args: ['class.queue']
            }] } });

class FsFileModule {
    static forRoot(config = null) {
        return {
            ngModule: FsFileModule,
            providers: [
                {
                    provide: FS_FILE_MODULE_CONFIG,
                    useValue: config || {
                        allowDownload: true,
                        allowRemove: true,
                        dragoverMessage: true,
                    },
                },
            ],
        };
    }
}
FsFileModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsFileModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileModule, declarations: [FsFileComponent,
        FsFilePreviewsComponent,
        FsFilePreviewComponent,
        FsFilePreviewActionDirective,
        FsFileDragBaseComponent,
        FsFilePickerComponent,
        FsFileImagePickerComponent,
        FsFileBouncingIconComponent,
        FsFileDragoverMessageComponent,
        FsFileImagePickerDialogComponent,
        FsFileHintDirective,
        FsFileLabelDirective,
        FsFileSrcPipe,
        FilePreviewMapFilePipe,
        FsFilePickerSelectDirective], imports: [FormsModule,
        CommonModule,
        MatIconModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        FsLabelModule], exports: [FsFileComponent,
        FsFilePreviewsComponent,
        FsFilePreviewComponent,
        FsFilePreviewActionDirective,
        FsFilePickerComponent,
        FsFileImagePickerComponent,
        FsFileHintDirective,
        FsFileLabelDirective,
        FsFilePickerSelectDirective,
        FsFileSrcPipe] });
FsFileModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileModule, imports: [[
            FormsModule,
            CommonModule,
            MatIconModule,
            MatTooltipModule,
            MatProgressSpinnerModule,
            MatButtonModule,
            MatDialogModule,
            MatFormFieldModule,
            MatInputModule,
            FsLabelModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsFileModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        CommonModule,
                        MatIconModule,
                        MatTooltipModule,
                        MatProgressSpinnerModule,
                        MatButtonModule,
                        MatDialogModule,
                        MatFormFieldModule,
                        MatInputModule,
                        FsLabelModule,
                    ],
                    exports: [
                        FsFileComponent,
                        FsFilePreviewsComponent,
                        FsFilePreviewComponent,
                        FsFilePreviewActionDirective,
                        FsFilePickerComponent,
                        FsFileImagePickerComponent,
                        FsFileHintDirective,
                        FsFileLabelDirective,
                        FsFilePickerSelectDirective,
                        FsFileSrcPipe,
                    ],
                    declarations: [
                        FsFileComponent,
                        FsFilePreviewsComponent,
                        FsFilePreviewComponent,
                        FsFilePreviewActionDirective,
                        FsFileDragBaseComponent,
                        FsFilePickerComponent,
                        FsFileImagePickerComponent,
                        FsFileBouncingIconComponent,
                        FsFileDragoverMessageComponent,
                        FsFileImagePickerDialogComponent,
                        FsFileHintDirective,
                        FsFileLabelDirective,
                        FsFileSrcPipe,
                        FilePreviewMapFilePipe,
                        FsFilePickerSelectDirective,
                    ],
                }]
        }] });

function ScaleExifImage(canvas, orientation, maxWidth = null, maxHeight = null) {
    let width = canvas.width;
    let height = canvas.height;
    if (maxWidth) {
        if (maxWidth < width) {
            width = maxWidth;
        }
    }
    if (maxHeight) {
        if (maxHeight < height) {
            height = maxHeight;
        }
    }
    const rotatedImage = document.createElement('canvas');
    rotatedImage.width = width;
    rotatedImage.height = height;
    const rotatedCtx = rotatedImage.getContext('2d');
    switch (orientation) {
        case 2:
        case 4:
        case 5:
        case 7:
            rotatedCtx.scale(-1, 1);
            rotatedCtx.drawImage(canvas, 0, 0, width, height, -width, 0, width, height);
            return rotatedImage;
        default:
            return canvas;
    }
}

function isImageType(type) {
    return !!type
        .match(/^image\/(gif|jpe?g|pjpeg|png|svg\+xml|tiff|vnd\.microsoft\.icon|vnd\.wap\.wbmp|webp)/i);
}

/**
 * Generated bundle index. Do not edit.
 */

export { FS_FILE_CLICK_INTERCEPTOR, FileClickHandler, FileClickInterceptor, FileProcessor, FsFile, FsFileComponent, FsFileDragBaseComponent, FsFileHintDirective, FsFileImagePickerComponent, FsFileLabelDirective, FsFileModule, FsFilePickerComponent, FsFilePickerSelectDirective, FsFilePreviewActionDirective, FsFilePreviewComponent, FsFilePreviewsComponent, FsFileSrcPipe, InputProcessorService, ScaleExifImage, isImageType };
